{
  "(MitDiesemGeschäftGeschlossen)": "(Mit diesem Geschäft geschlossen)",
  "(mit Ertragswertkomponente)": "(mit Ertragswertkomponente)",
  "ABBRUCH": "Abbruch",
  "ABGEBROCHEN": "Abgebrochen",
  "ABGESCHLOSSEN_MIT_GRUNDBUCH": "Abgeschlossen mit Grundbuch",
  "ABGESCHLOSSEN_OHNE_GRUNDBUCH": "Abgeschlossen ohne Grundbuch",
  "ABGEWIESEN": "Abgewiesen",
  "ABGEWIESEN_AUSGETRAGEN": "Abgewiesen Ausgetragen",
  "ABSCHLUSS": "Abschluss",
  "ACI": "ACI",
  "ACKER_WIESE_PFLANZLAND_BAUMGARTEN_BISHER": "Acker, Wiese, Pflanzgarten, Baumgarten",
  "ADG": "ADG",
  "ADG_lang": "Ancien droit Genevois",
  "AHV-Nr/UID": "AHV-Nr / UID",
  "AHVNummer": "AHV-Nummer (alt)",
  "AHVVersichertennummer": "AHV-Nummer",
  "AKUTSPITAELER_ALLGEMEINE_SPITAELER": "Akutspitäler, allgemeine Spitäler",
  "ALLE": "Alle",
  "ALLEINEIGENTUM": "Alleineigentum",
  "ALLE_PERSON": "Alle",
  "ALTRECHTLICH": "Altrechtlich",
  "AMWARTEN": "Ausstehend",
  "ANDERE": "andere AV Bemerkung",
  "ANDEREADRESSE": "Andere Adresse",
  "ANDEREART": "Andere Art",
  "ANDEREROLLE": "andere Rolle",
  "ANDERE_BEHERBERGUNGEN": "Andere Beherbergungen",
  "ANDERE_GEBAEUDE_FUER_DIE_KOLLEKTIVE_UNTERKUNFT": "Andere Gebäude für die kollektive Unterkunft",
  "ANDERE_GEBAEUDE_FUER_KURZFRISTIGE_BEHERBERGUNGEN": "Andere Gebäude für kurzfristige Beherbergungen",
  "ANDERE_LANDWIRTSCHAFTLICHE_GEBAEUDE": "Andere landwirtschaftliche Gebäude",
  "ANDERE_WOHNGEBAEUDE": "Andere Wohngebäude (Wohngebäude mit Nebennutzung)",
  "ANMERKUNG": "Anmerkung",
  "ANMERKUNG_KURZ": "AN",
  "ANREDE": "Anrede",
  "AUFGABE": "Aufgabe",
  "AUFGEHOBEN": "Aufgehoben",
  "AUFGELOESTEPARTNERSCHAFT": "Aufgelöste Partnerschaft",
  "AUSLAENDISCHE_GEMEINDE": "Ausländische Gemeinde",
  "AUSLAENDISCHE_RECHTSFORM": "Ausländische Rechtsform",
  "AV-Mutation": "AV-Mutation",
  "AV-Mutationsnummer": "Mutationsnummer",
  "AV_BEMERKUNG": "AV-Bemerkung",
  "AW": "AW",
  "AW: ": "AW: ",
  "Abbrechen": "Abbrechen",
  "Abbruchjahr": "Abbruchjahr",
  "Ablaufdatum": "Ablaufdatum",
  "Abschluss (Rechtsgültigsetzung)": "Abschluss (Rechtsgültigsetzung)",
  "Abschlussdatum": "Abschlussdatum",
  "Abschnittflaeche": "Abschnittfläche",
  "AdminNr": "Admin Nr.",
  "AdminWohnungsnummer": "Admin. Wohnungsnummer",
  "Adresse": "Adresse",
  "AdresseEingang": "Adresse / Eingang",
  "AdresseKopieren": "Adresse in die Zwischenablage kopieren",
  "AdresseWurdeKopiert": "Adresse wurde in die Zwischenablage kopiert",
  "Adressen": "Adressen",
  "AdressenAufbereiten": "Adressen aufbereiten",
  "AdressenN": "Adresse(n)",
  "AktenempfaengerFreitext": "Aktenempfänger Freitext",
  "Aktueller Betrachtungskontext": "Aktueller Betrachtungskontext",
  "Alle": "Alle",
  "Alleineigentum": "Alleineigentum",
  "Alpgrundstuecke": "Alpgrundstücke",
  "AlteIdentifikation": "Alte ID (Datum, ID)",
  "AmtlicheBaudossiernummer": "Amtl. Baudossier-Nr.",
  "AmtlicheBaudossiernummerZusatz": "Amtl. Baudossier-Nr. Zusatz",
  "AmtlicheBewertung": "Amtliche Bewertung",
  "AmtlicherWert": "Amtlicher Wert",
  "AngefordertenRessourceWurdeNeueUriZugewiesen": "Der angeforderten Ressource wurde eine neue permanente URI zugewiesen.",
  "Anmelder": "Anmeldende Person",
  "AnmelderText": "Anmeldende Person Text",
  "Anmerkung": "Anmerkung",
  "AnmerkungAmtlicheVermessung": "Bemerkungen AV",
  "Anmerkungen": "Anmerkungen",
  "Anmerkungsgrundstueck": "Anmerkungsgrundstueck",
  "Annulliert": "Annulliert",
  "Anrede": "Anrede",
  "Anteil": "Anteil",
  "AnteilAmDominiertenGrundstueck": "Anteil am dominierten Grundstück",
  "AnteilAmStammgrundstueck": "Anteil am Stammgrundstück",
  "AnteilEigentum": "Anteil Eigentum",
  "AnzahlGebaeude": "Anzahl betroffene Gebäude",
  "AnzahlGeschosse": "Anzahl Geschosse",
  "AnzahlWohnraeume": "Anzahl separater Wohnräume",
  "AnzahlWohnungen": "Anzahl Wohnungen",
  "AnzahlZimmer": "Anzahl Zimmer",
  "Anzeige": "Anzeige",
  "AnzeigeBauprojekt": "Details zu Bauprojekt anzeigen",
  "AnzeigeGebäude": "Details zu Gebäude anzeigen",
  "AnzeigeWohnung": "Details zu Wohnung anzeigen",
  "Art": "Art",
  "ArtDerArbeiten": "Art der Arbeiten",
  "ArtDerBauwerke": "Art der Bauwerke",
  "AufbereitungsoptionenEigentuemerAuszug": "Aufbereitungsoptionen Eigentümer-Auszug",
  "AufbereitungsoptionenGrundstueckAuszug": "Aufbereitungsoptionen Grundstück-Auszug",
  "AufbereitungsoptionenRechteAuszug": "Aufbereitungsoptionen Rechte-Auszug",
  "Aufklappen": "aufklappen",
  "Auftraege": "Aufträge",
  "Auftrag": "Auftrag",
  "Auftrag senden": "Auftrag senden",
  "Auftrag.SucheTitel": "Suche nach Aufträgen",
  "AuftragLoeschen": "Auftrag löschen",
  "AuftragMitNummerErfolgreichErstellt": "Auftrag mit Nummer {{auftragsNummer}} wurde erfolgreich erstellt",
  "AuftraggeberFreitext": "Auftraggeber Freitext",
  "Auftrags-Nr": "Auftrags-Nr",
  "AuftragsNr": "Auftrags-Nr.",
  "AuftragsNummerAblage": "Auftrags-Nr / Ablage",
  "AuftragsTyp": "Auftrags-Typ",
  "Auftragsdatum": "Auftragsdatum",
  "Ausgang": "Ausgang",
  "AusserbuchlicherUebergang": "Ausserbuchlicher Übergang",
  "Auswahl": "Auswahl",
  "Auszug": "Auszug",
  "AuszugBearbeiten": "Auszug bearbeiten",
  "AuszugErstellen": "Auszug erstellen",
  "AuszugZuANMERKUNGErstellen": "Auszug zu Anmerkung {{param}} erstellen",
  "AuszugZuDIENSTBARKEITErstellen": "Auszug zu Dienstbarkeit {{param}} erstellen",
  "AuszugZuEIGENTUMANTEILErstellen": "Auszug zu Eigentumanteil {{param}} erstellen",
  "AuszugZuEigentuemerErstellen": "Eigentümerauszug zu {{param}} erstellen",
  "AuszugZuGRUNDLASTErstellen": "Auszug zu Grundlast {{param}} erstellen",
  "AuszugZuGrundbuchmeldungErstellen": "Auszug zu Grundbuchmeldung erstellen",
  "AuszugZuGrundstueckErstellen": "Auszug zu Grundstück {{param}} erstellen",
  "AuszugZuPFANDRECHTErstellen": "Auszug zu Pfandrecht {{param}} erstellen",
  "AuszugZuRechtErstellen": "Auszug zu Recht {{param}} erstellen",
  "AuszugZuSDR_DIENSTBARKEITErstellen": "Auszug zu SDR Dienstbarkeit {{param}} erstellen",
  "AuszugZuVORMERKUNGErstellen": "Auszug zu Vormerkung {{param}} erstellen",
  "Auszüge": "Auszüge",
  "AvBemerkung": "AV Bemerkung",
  "AvMutation": "AV-Mutation",
  "BAHNANLAGEN": "Bahnanlagen",
  "BAHNEN_STRASSEN_WEGE_BISHER": "Bahnen, Strassen, Wege",
  "BAHNHOEFE_ABFERTIGUNGSGEBAEUDE_FERNSPRECHVERMITTLUNGSZENTRALEN": "Bahnhöfe, Abfertigungsgebäude, Fernsprechvermittlungszentralen",
  "BAUBEWILLIGUNG_BEWILLIGT": "Baugesuch bewilligt",
  "BAUGESUCH_ABGELEHNT": "Baugesuch abgelehnt",
  "BAUGESUCH_BEANTRAGT": "Baugesuch beantragt",
  "BAURECHT": "Baurecht",
  "BE-EDID": "BE-EDID",
  "BEARBEITET": "Bearbeitet",
  "BEARBEITUNG": "In Bearbeitung",
  "BEFESTIGT_BAHN": "Bahn",
  "BEFESTIGT_FLUGPLATZ": "Flugplatz",
  "BEFESTIGT_STRASSE_WEG": "Strasse, Weg",
  "BEFESTIGT_TROTTOIR": "Trottoir",
  "BEFESTIGT_UEBRIGE_BEFESTIGTE": "Übrige befestigte Fläche",
  "BEFESTIGT_VERKEHRSINSEL": "Verkehrsinsel",
  "BEFESTIGT_WASSERBECKEN": "Wasserbecken",
  "BEHAELTER_SILOS_UND_LAGERGEBAEUDE": "Behälter, Silos und Lagergebäude",
  "BELASTET": "Belastet",
  "BELASTET_BERECHTIGT": "Belastet/Berechtigt",
  "BERECHTIGT": "Berechtigt",
  "BEREINIGUNG": "Bereinigung",
  "BEREITZURUEBERNAHME": "Bereit zur Übernahme",
  "BEREIT_FUER_GRUNDBUCH": "Bereit für Grundbuch",
  "BEREIT_FUER_KORREKTURLIEFERUNG": "Bereit für Korrektur",
  "BEREIT_FUER_TAGEBUCH": "Bereit für Tagebuch",
  "BEREIT_FUER_VERARBEITUNG": "Bereit für Verarbeitung",
  "BEREIT_ZUR_VERIFIKATION": "Bereit zur Verifikation",
  "BERGWERK": "Bergwerk",
  "BERGWERK_ausg": "Bergwerk",
  "BESTEHEND": "Bestehend",
  "BESTOCKT_GESCHLOSSENER_WALD": "Geschlossener Wald",
  "BESTOCKT_UEBRIGE_BESTOCKTE": "Übrige bestockte Fläche",
  "BESTOCKT_WYTWEIDE_WYTWEIDE_DICHT": "Wytweide dicht",
  "BESTOCKT_WYTWEIDE_WYTWEIDE_OFFEN": "Wytweide, offen",
  "BEWERTUNGSGRUND": "Bewertungsgrund",
  "BEWILLIGT": "Bewilligt",
  "BODENBEDECKUNG": "Bodenbedeckung",
  "BUEROGEBAEUDE": "Bürogebäude",
  "BUEROGEBAEUDE_VERWALTUNGSGEBAEUDE": "Bürogebäude, Verwaltungsgebäude",
  "BUS_TRAMANLAGEN": "Bus- und Tramanlagen",
  "Bauart": "Bauart",
  "Baueingabe": "Baueingabe",
  "BaugesuchAbgelehnt": "Baugesuch abgelehnt",
  "BaugesuchBeantragt": "Baugesuch beantragt",
  "BaugesuchBewilligt": "Baugesuch bewilligt",
  "Baujahr": "Baujahr",
  "Bauort": "Bauort",
  "BauortMussVorhandenSein": "Der Bauort muss vorhanden sein.",
  "Bearbeiter": "Bearbeiter",
  "Bearbeitet": "Bearbeitet",
  "Bearbeitungsstatus": "Bearbeitungsstatus",
  "Belastet": "L",
  "BelastetBerechtigt": "LR",
  "BelastetMit": "Belastet mit SDR",
  "BelastetOderBerechtigt": "Belastete Grundstücke",
  "BelasteteTeilflaechen": "Belastete Teilflächen",
  "Belastung": "Belastung",
  "Beleg": "Beleg",
  "BelegAlt": "Beleg alt",
  "Belegamt": "Belegamt",
  "Belegdatum": "Entstehungsdatum",
  "BelegeZuGrundbuchgeschäft": "Belege zu Grundbuchgeschäft ",
  "Bemerkung": "Bemerkung",
  "BemerkungGrundbuch": "Bemerkungen Grundbuch",
  "Bemerkungen": "Bemerkungen",
  "Berechtigt": "R",
  "BerechtigtAn": "Berechtigt an ",
  "BerechtigtePersonen": "Berechtigte Personen",
  "Bereinigungsmarkierung": "Bereinigungsmarkierung",
  "BereitFuerGrundbuch": "Datum bereit für Grundbuch",
  "BereitfürGrundbuch": "Bereit für Grundbuch",
  "Beschreibung": "Beschreibung",
  "BeteiligteGrundstuecke": "Beteiligte Grundstücke",
  "BetroffeneGebäude": "Betroffene Gebäude",
  "BetroffeneGemeinden": "Betroffene Gemeinden",
  "BetroffeneGrundstücke": "Betroffene Grundstücke",
  "Bewertung": "Bewertung",
  "Bezeichnung": "Bezeichnung",
  "BezugZumGrundbuch": "Bezug zum Grundbuch",
  "Bodenbedeckung": "Bodenbedeckung",
  "BodenbedeckungGeschichte": "Geschichte berücksichtigen",
  "CFA": "CFA",
  "CFA_lang": "Construction",
  "CSV": "CSV",
  "Close": "Schliessen",
  "CodeGläubiger": "Code Gläubiger/in",
  "CodeNachRechtart": "Code nach Rechtart",
  "CodeSchuldner": "Code Schuldner/in",
  "DEFAULT_MIT_GRUNDBUCH": "Mit Grundbuch",
  "DEFAULT_OHNE_GRUNDBUCH": "Ohne Grundbuch",
  "DEFINITIV": "Definitiv",
  "DENKMAELER_ODER_UNTER_DENKMALSCHUTZ_STEHENDE_BAUWERKE": "Denkmäler oder unter Denkmalschutz stehende Bauwerke",
  "DIENSTBARKEIT": "Dienstbarkeit",
  "DIENSTBARKEIT_GRUNDLAST": "Grundlast",
  "DIENSTBARKEIT_KURZ": "DI",
  "DOMINANTINDENT": "DOMINANTINDENT",
  "DOMINANTINDET": "Dominantindet",
  "DPI": "DPI",
  "DPI_lang": "Domaine public immatriculé",
  "DRINGEND": "Dringend",
  "DarinEnthalteneZugaben": "Darin enthaltene Zugaben",
  "Dateiformat": "Dateiformat",
  "Datenquelle": "Datenquelle",
  "Datenschutzbereinigt": "Datenschutzbereinigt",
  "Datum": "Datum",
  "Datum Auftrag": "Datum Auftrag",
  "DatumAuftrag": "Datum Auftrag",
  "DatumBaubeginn": "Datum Baubeginn",
  "DatumBaubewilligung": "Datum Baubewilligung",
  "DatumBauende": "Datum Bauende",
  "DatumBis": "Datum Bis",
  "DatumDesExports": "Datum des Export",
  "DatumEingabe": "Publikationsdatum",
  "DatumEingabeFehler": "Zeitraum für Publikationsdatum darf höchstens {{tage}} Tage betragen",
  "DatumEntstehung": "Datum Entstehung",
  "DatumEntstehungErgänzung": "Datum (Entstehung/Ergänzung)",
  "DatumJahrEingabeFormatBeispiel": "jjjj",
  "DatumMonatEingabeFormatBeispiel": "mm",
  "DatumNutzenUndGefahr": "Datum Nutzen und Gefahr",
  "DatumOderBeleg": "Datum/Beleg",
  "DatumOderBelegOderEntstehung": "Datum/Beleg/Entstehung",
  "DatumOderBelegOderRechtsgrund": "Datum/Beleg/Rechtsgrund",
  "DatumOderEntstehungOderRechtsgrund": "Datum/Beleg/Rechtsgrund",
  "DatumProjekteingabe": "Datum Baueingabe",
  "DatumRechtsgrund": "Datum Rechtsgrund",
  "DatumTagEingabeFormatBeispiel": "tt",
  "DatumVertragsabschluss": "Datum Vertragsabschluss",
  "DatumVon": "Datum Von",
  "DerServerMeldetEinenTechnischenFehler": "Der Server meldet einen technischen Fehler (HTTP {{status}})",
  "Detaillierungsgrad": "Detaillierungsgrad",
  "DetailsZuArtAnzeigen": "Details zu {{art}} anzeigen",
  "DetailsZuGebaeudeWohnungsregister": "Details Gebäude-, Wohnungsregister",
  "DetailsZuGrundstueckAusSichtGrundbuch": "Details zu Grundstück aus Sicht Grundbuch",
  "DetailsZuGwrGebäude": "Details zu GWR-Gebäude",
  "DetailsZumGeschaeftAnzeigen": "Details zum Geschäft anzeigen",
  "DetailsZumLöschgeschaeftAnzeigen": "Details zu Löschgeschäft anzeigen",
  "Dienstbarkeit": "Dienstbarkeit",
  "DienstbarkeitDetail": "Dienstbarkeit-Detail",
  "Dienstbarkeiten": "Dienstbarkeiten",
  "Dokumente": "Dokumente",
  "DokumenteZuAlteGrundbuchmeldung": "Alte Grundbuchmeldung zu Geschäft {{param}}",
  "DokumenteZuBeleg": "Dokumente zu Beleg {{param}}",
  "DokumenteZuGeschaeft": "Dokumente zu Geschäft {{param}}",
  "DokumenteZuGrundstueck": "Dokumente zu Grundstück {{param}}",
  "DokumenteZuRecht": "Dokumente zu Recht {{param}}",
  "DominantIndet": "*DI",
  "DominierendeGrundstuecke": "Dominierende Grundstücke",
  "DominierteGrundstuecke": "Dominierte Grundstücke",
  "Dossiernummer": "Dossiernummer",
  "DossiernummerdSuche": "DossiernummerdSuche",
  "EBelege": "eBelege",
  "EDID": "EDID",
  "EGBPID": "EGBPID",
  "EGBTBID": "EGBTBID",
  "EGBTBIDSuche": "EGBTBIDSuche",
  "EGID": "EGID",
  "EGID_EWID": "EGID / EWID",
  "EGRID": "E-GRID",
  "EGVAnmeldung": "eGV Anmeldung",
  "EIDGENOESSISCH": "Eidgenössisch",
  "EIGENTUEMER": "Eigentümerinnen und Eigentümer",
  "EINFACHEGESELLSCHAFT": "Einfache Gesellschaft",
  "EINFAMILIENHAEUSER": "Einfamilienhäuser",
  "EINFAMILIENHAEUSER_ANGEBAUT": "Einfamilienhäuser angebaut",
  "EINFAMILIENHAEUSER_FREISTEHEND": "Einfamilienhäuser freistehend",
  "EINFUEHRUNG": "Einführung EGB im Gange",
  "EINGEDOLTES_GEWAESSER": "eingedoltes Gewässer",
  "EINMALIG": "Einmalig",
  "EINZELPFANDRECHT": "Einzelpfandrecht",
  "EINZELPFANDRECHT_KURZ": "E",
  "ELEKTRIZITAETSWERKE_NETZE": "Elektrizitätswerke und -netze",
  "EPROID": "EPROID",
  "ERBENGEMEINSCHAFT": "Erbengemeinschaft",
  "EREID": "EREID",
  "EROEFFNET": "Eröffnet",
  "ERSTERHEBUNG_ERNEUERUNG": "Ersterhebung / Erneuerung",
  "ERWERBER": "Erwerber",
  "EW": "EW",
  "EXMATRIKULIERT": "Exmatrikuliert",
  "EXTERNER_HINWEIS": "Externer Hinweis",
  "EgbpidSuche": "EGBPID Suche",
  "EgbtbidSuche": "EGBTBID Suche",
  "EgidSuche": "EGID Suche",
  "EgridSuche": "Suche mit E-GRID",
  "EgvtBelege": "eGV Belege",
  "Eigentuemer": "Eigentum",
  "Eigentum": "Eigentum",
  "EigentumErweitern": "Eigentum erweitern",
  "EigentumExportieren": "Eigentum Exportieren",
  "Eigentumsform": "Eigentumsform",
  "Eigentumsform.ALLEINEIGENTUM": "Alleineigentum",
  "Eigentumsform.GESAMTEIGENTUM": "Gesamteigentum",
  "Eigentumsform.MITEIGENTUM": "Miteigentum",
  "EigentümerBisher": "Bisher im Eigentum von",
  "EigentümerMitAdresseAufbereiten": "Eigentümer/innen mit Adresse aufbereiten",
  "EigentümerNeu": "Neu im Eigentum von",
  "Eigentümerauszug": "Eigentümerauszug",
  "EinTechnischerFehlerIstAufgetreten": "Ein technischer Fehler ist aufgetreten.",
  "EingabeDarfNichtLeerSein": "Eingabe darf nicht leer sein",
  "EingabeGemeindeErforderlich": "Die Eingabe einer Gemeinde ist erforderlich",
  "EingabeGrundbuchamtErforderlich": "Die Eingabe eines Grundbuchamtes ist erforderlich",
  "EingabeIstZuLange": "Eingabe ist zu lange",
  "EingabeMussFolgendesFeldAngegebenHaben": "\"{{Feld}}\" muss angegeben werden",
  "EingabeMussGenauEineGemeindeAusgewaehltHaben": "Es muss genau eine Gemeinde ausgewählt werden",
  "EingabeMussGueltigeHaunsummerSein": "Eingabe muss gültige Hausnummer sein (z.B. 2a)",
  "EingabeMussGueltigeStrasseSein": "Eingabe muss mindestens 2 Zeichen enthalten",
  "EingabeMussJahrSein": "Eingabe muss Jahr mit 4 Stellen sein",
  "EingabeMussMindestensEinGrundstueckTypAusgewaehltHaben": "Es muss mindestens ein Grundstueck typ ausgewählt sein",
  "EingabeMussMindestensEineBodenbedeckungAusgewaehltHaben": "Es muss mindestens eine Bodenbedeckung ausgewählt sein",
  "EingabeMussMindestensEineGrundstueckbeschreibungHaben": "Es muss mindestens eine Grundstückbeschreibung ausgewählt sein",
  "EingabeMussMindestensEinePersonenartAusgewaehltHaben": "Es muss mindestens eine Personenart ausgewählt sein",
  "EingabeMussMindestensEineRechteArtAusgewaehltHaben": "Es muss mindestens eine Rechteart ausgewählt sein",
  "EingabeMussMindestensEineRubrikAusgewaehltHaben": "Es muss mindestens eine Rubrik ausgewählt sein",
  "EingabeMussValideAHVNummerSein": "Eingabe muss eine valide AHV Nummer sein",
  "EingabeMussValideBaudossiernummerSein": "Eingabe muss eine valide Baudossiernummer sein",
  "EingabeMussValideEgbpidSein": "Eingabe muss eine valide EGBPID sein (z.B. CH123577617789)",
  "EingabeMussValideEgbtbidSein": "Eingabe muss eine valide EGBTBID sein (z.B. CH123577617789)",
  "EingabeMussValideEgidSein": "Eingabe muss eine valide EGID sein",
  "EingabeMussValideEgridSein": "Eingabe muss eine valide E-GRID sein",
  "EingabeMussValideEmailSein": "Eingabe muss eine valide Email sein",
  "EingabeMussValideEproidSein": "Eingabe muss eine valide EPROID sein",
  "EingabeMussValideEreidSein": "Eingabe muss eine valide EREID sein",
  "EingabeMussValideGrundstueckNummerSein": "Eingabe muss eine valide Grundstück Nummer sein",
  "EingabeMussValideNummerSein": "Eingabe muss eine Zahl sein",
  "EingabeMussValideNummerSein-EGID": "Eingabe muss eine Zahl sein. Achtung: Hier wird ein EGID (eidgenössischer Gebäudeidentifikator), nicht E-GRID (eidgenössische Grundstücksidentifikation) erwartet.",
  "EingabeMussValideNummerSein5Stellen>80k": "Für die Suche nach Spezialrechten muss eine 5-stellige Nummer > 80000 eingegeben werden",
  "EingabeMussValideNummerSeinBeispiel": "Eingabe muss eine Zahl in der Form 2018 sein",
  "EingabeMussValidePLZSein": "Eingabe muss eine valide PLZ sein",
  "EingabeMussValideUIDSein": "Eingabe muss eine valide UID sein",
  "EingabeMussValideVersicherungsNummerSein": "Eingabe muss valide Versicherungsnummer sein",
  "EingabeMussValiderBaudossiernummerZusatzSein": "Eingabe muss ein valider Baudossiernummerzusatz sein",
  "EingabeMussValiderMonatSein": "Must be a valid month",
  "EingabeMussValiderTagSein": "Eingabe muss ein gültiger Tag sein",
  "EingabeMussValidesDatumSeinBeispiel": "Eingabe muss ein Datum in der Form 31.12.2018 sein",
  "EingabeMussValidesJahrSein": "Eingabe muss ein gültiges Jahr sein",
  "EingabeNichtValide(1-30Zeichen)": "Eingabe ist nicht valide (muss 1-30 Zeichen enthalten)",
  "EingabeUploadFileNichtValidOderNameExistiert": "Die Liste ist nicht korrekt formatiert oder der Dateiname existiert bereits",
  "Eingang": "Eingang",
  "Eingangsdatum": "Eingangsdatum",
  "Einstellungen": "Einstellungen",
  "EinstellungenSpeichernBisZurNaechstenAbmeldung": "Einstellungen speichern (bis zur nächsten Abmeldung)",
  "EinstellungenZuruecksetzen": "Einstellungen zurücksetzen",
  "Eintraege": "Einträge",
  "Eintrag": "Eintrag",
  "Eintragung": "Eintragung",
  "EintragungenImGrundbuch": "Eintragungen im Grundbuch",
  "Einzelobjekt": "Einzelobjekt",
  "EinzelobjektAbkürzung": "EO",
  "Enddatum": "Enddatum",
  "EnthalteneZugaben": "Darin enthaltenen Zugaben",
  "Entschädigung": "Entschädigung",
  "EntstandenAus": "Entstanden aus",
  "Entstehungsdatum": "Entstehungsdatum",
  "EproidSuche": "EproidSuche",
  "EreidSuche": "EREID Suche",
  "EreidsAufbereiten": "EREIDs aufbereiten",
  "ErgebnisoptionenEigentum": "Ergebnisoptionen Eigentum",
  "ErgebnisoptionenGrundstueckbeschreibung": "Ergebnisoptionen Grundstückbeschreibung",
  "ErgebnisoptionenStammperson": "Ergebnisoptionen Stammperson",
  "ErrorGettingMap": "Fehler beim Laden des Plans",
  "ErrorWhileLoading": "Während der Bearbeitung der Abfrage ist ein Fehler aufgetreten. Möglicherweise sind die angezeigten Daten unvollständig. Bitte versuchen Sie es später noch einmal.",
  "Erstelldatum": "Erstelldatum",
  "ErstelltMit": "Erstellt mit",
  "ErstelltVon": "Erstellt von",
  "Ersterfassung": "Ersterfassung",
  "ErsterfassungÜbergeben": "Ersterfassung übergeben",
  "Erweitert": "Erweitert",
  "ErweiterteSuche": "Erweiterte Suche",
  "Erwerber": "Erwerber",
  "Erwerbsangaben": "Erwerbsangaben",
  "Export": "Export",
  "FAUSTPFANDGLAEUBIGER": "Faustpfandgläubiger/in",
  "FEHLERHAFT": "Fehlgeschlagen",
  "FEHLERLOS": "Erfolgreich",
  "FERNHEIZUNGSANLAGEN": "Fernheizungsanlagen",
  "FLAECHENBERICHTIGUNG": "Flächenberichtigung",
  "FLUGVERKEHRSANLAGEN": "Flugverkehrsanlagen",
  "FLURNAME": "Flurname",
  "FOLIO": "Folio",
  "FOLIO_ausg": "Folio",
  "FORSTWIRTSCHAFTSBAUTEN": "Forstwirtschaftsbauten",
  "FREIZEIT_TOURISMUSANLAGEN": "Freizeit-, Tourismusanlagen",
  "FUNKTION_BENUTZER": "Funktion Benutzer",
  "FehlerBeimAufrufDesWebservice": "Fehler beim Aufruf des Webservice",
  "Fehlermeldungen": "Fehlermeldungen",
  "Flaeche": "Fläche",
  "FlaecheNichtAusgeschieden": "Flächenmässig nicht ausgeschieden.",
  "FlaecheWertquote": "Fläche / Wertquote",
  "Flaechenanteile": "Flächenanteile SDR",
  "Flurname": "Flurname",
  "Folio": "Folio",
  "FormDerFuehrung": "Form der Führung",
  "FremdId": "Fremd-ID",
  "FremdeIdentifikation": "Fremde Identifikation",
  "Fremdsystem": "Fremdsystem",
  "FremdsystemFehler": "Ein Fremdsystem kann zu dieser Anfrage im Moment keine Daten liefern.",
  "FremdsystemNeskoFehler": "Beim Aufruf von Nesko AB ist ein Fehler aufgetreten.",
  "GARAGENGEBAEUDE": "Garagengebäude",
  "GARAGEN_PARKPLAETZE_EINSTELLHALLEN_IM_ZUSAMMENHANG_MIT_WOHNGEBAEUDEN": "Garagen, Parkplätze, Einstellhallen im Zusammenhang mit Wohngebäuden",
  "GASWERKE_NETZE_CHEMISCHE_ANLAGEN": "Gaswerke und -netze, chemische Anlagen",
  "GB_AUSZUG_LIG": "Grundbuchauszug Liegenschaft",
  "GB_AUSZUG_MIT": "Grundbuchauszug Miteigentum",
  "GB_AUSZUG_SDR": "Grundbuchauszug SDR",
  "GB_AUSZUG_SEYBUCH": "Grundbuchauszug Seybuch",
  "GB_AUSZUG_STW": "Grundbuchauszug Stockwerkeigentum",
  "GB_DETAIL_PFANDRECHT": "Rechteübersicht Pfandrecht",
  "GB_DETAIL_STANDARDRECHT": "Rechteübersicht Standardrecht",
  "GB_GEMEINDEKREIS": "Grundbuchkreis",
  "GB_GEMEINDE_OHNEKREIS": "Grundbuchgemeinde",
  "GB_UEBERSICHT_LIG": "Grundstückübersicht Liegenschaft",
  "GB_UEBERSICHT_MIT": "Grundstückübersicht Miteigentum",
  "GB_UEBERSICHT_SDR": "Grundstückübersicht SDR",
  "GB_UEBERSICHT_STW": "Grundstückübersicht Stockwerkeigentum",
  "GEBAEUDE": "Gebäude",
  "GEBAEUDEKATEGORIE": "Gebäudekategorie",
  "GEBAEUDEKLASSE": "Gebäudeklasse",
  "GEBAEUDESTATUS": "Gebäudestatus",
  "GEBAEUDE_FUER_DEN_PFLANZENBAU": "Gebäude für den Pflanzenbau",
  "GEBAEUDE_FUER_DIE_TIERHALTUNG": "Gebäude für die Tierhaltung",
  "GEBAEUDE_FUER_KULTUR_UND_FREIZEITZWECKE": "Gebäude für Kultur- und Freizeitzwecke",
  "GEBAEUDE_HOFRAUM_GARTEN_ANLAGE_BISHER": "Gebäude, Hofraum, Garten, Anlagen",
  "GEBAEUDE_MIT_AUSSCHLIESSLICHER_WOHNNUTZUNG": "Gebäude mit ausschliesslicher Wohnnutzung",
  "GEBAEUDE_MIT_DREI_ODER_MEHR_WOHNUNGEN": "Gebäude mit drei oder mehr Wohnungen",
  "GEBAEUDE_MIT_EINER_WOHNUNG": "Gebäude mit einer Wohnung",
  "GEBAEUDE_MIT_TEILWEISER_WOHNNUTZUNG": "Gebäude mit teilweiser Wohnnutzung",
  "GEBAEUDE_MIT_ZWEI_WOHNUNGEN": "Gebäude mit zwei Wohnungen",
  "GEBAEUDE_OHNE_WOHNNUTZUNG": "Gebäude ohne Wohnnutzung",
  "GEBAUT": "Gebaut",
  "GEBUEHR": "Gebühr",
  "GEMEINDERSCHAFT": "Gemeinderschaft",
  "GEMEINDESTRASSEN": "Gemeindestrassen",
  "GEMEINSCHAFT": "Gemeinschaft",
  "GEO_LINK": "GeoLink",
  "GESAMTEIGENTUM": "Gesamteigentum",
  "GESAMTPFANDRECHT": "Gesamtpfandrecht",
  "GESAMTPFANDRECHT_KURZ": "G",
  "GESAMTTEILPFANDRECHT": "Gesamtteilpfandrecht",
  "GESAMTTEILPFANDRECHT_KURZ": "GT",
  "GESCHAEFT_BESCHREIBUNG": "Beschreibung",
  "GESCHIEDEN": "Geschieden",
  "GESELLSCHAFTSFORM": "Gesellschaftsform",
  "GESETZLICHES_PFANDRECHT": "Gesetzliches Pfandrecht",
  "GEWAESSER_BISHER": "Gewässer",
  "GEWAESSER_FLIESSENDES": "Fliessendes Gewässer",
  "GEWAESSER_SCHILFGUERTEL": "Schilfgürtel",
  "GEWAESSER_STEHENDES": "Stehendes Gewässer",
  "GLAEUBIGER": "Gläubiger/in",
  "GLAEUBIGER_ROLLE": "Gläubiger",
  "GLAEUBIGER_SCHULDNER": "Gläubiger/in - Schuldner/in",
  "GROSS_UND_EINZELHANDELSGEBAEUDE": "Gross- und Einzelhandelsgebäude",
  "GRUNDBUCH": "Grundbuch",
  "GRUNDBUCH_ABGESCHLOSSEN": "Grundbuch abgeschlossen",
  "GRUNDLAST": "Grundlast",
  "GRUNDLAST_KURZ": "GL",
  "GRUNDPFANDGLAEUBIGER": "Grundpfandgläubiger/in",
  "GRUNDPFANDVERSCHREIBUNG": "Grundpfandverschreibung",
  "GRUNDSTUECK_UNTER_ART_LIG": "Unterart Liegenschaft",
  "GRUNDSTUECK_UNTER_ART_SDR": "Unterart SDR",
  "GUELT": "Gült",
  "GUETERGEMEINSCHAFT": "Gütergemeinschaft",
  "GWRBAUPERIODE_8011": "Periode vor 1919",
  "GWRBAUPERIODE_8012": "Periode von 1919 bis 1945",
  "GWRBAUPERIODE_8013": "Periode von 1946 bis 1960",
  "GWRBAUPERIODE_8014": "Periode von 1961 bis 1970",
  "GWRBAUPERIODE_8015": "Periode von 1971 bis 1980",
  "GWRBAUPERIODE_8016": "Periode von 1981 bis 1985",
  "GWRBAUPERIODE_8017": "Periode von 1986 bis 1990",
  "GWRBAUPERIODE_8018": "Periode von 1991 bis 1995",
  "GWRBAUPERIODE_8019": "Periode von 1996 bis 2000",
  "GWRBAUPERIODE_8020": "Periode von 2001 bis 2005",
  "GWRBAUPERIODE_8021": "Periode von 2006 bis 2010",
  "GWRBAUPERIODE_8022": "Periode von 2011 bis 2015",
  "GWRBAUPERIODE_8023": "Periode ab 2016",
  "GWRBauprojekt": "GWR-Bauprojekt",
  "GWRBauprojekte": "GWR-Bauprojekte",
  "GWRGebaeude": "GWR-Gebäude",
  "GWRWohnung": "GWR-Wohnung",
  "GbBemerkung": "GB-Bemerkung",
  "Gbgeschäfte": "Grundbuchgeschäfte",
  "Gebaeude": "Gebäude",
  "Gebaeude-Nr.": "Gebäude-Nr.",
  "GebaeudeAdresse": "Gebäude - Adresse",
  "Gebaeude_Einzahl": "Gebäude",
  "Gebaeudebezeichnung": "Gebäudebezeichnung",
  "Gebaeudeflaeche": "Gebäudefläche",
  "Gebaeudeschatzung": "Gebäudeschätzung",
  "Gebaut": "Gebaut",
  "Geburtsdatum": "Geburtsdatum",
  "GeburtsdatumGruendungsdatumaktivVon": "Geburtsdatum / Gründungsdatum / aktiv von",
  "GeburtsdatumJahr": "Geburtsdatum Jahr",
  "GeburtsdatumMonat": "Geburtsdatum Monat",
  "GeburtsdatumTag": "Geburtsdatum Tag",
  "Gebäude/Bauten": "Gebäude/Bauten",
  "GebäudeVersicherungsNummer": "Gebäude-Vers. Nr.",
  "GebäudeeingangsadresseAdressen": "Gebäudeeingangsadresse(n)",
  "GefundeneBauprojekte": "Gefundene GWR-Bauprojekte",
  "GefundeneGebäude": "Gefundene Gebäude",
  "GefundenePersonen": "Gefundene {{rolle}}",
  "GefundeneRechte": "Gefundene Rechte",
  "GeloeschteGrundstuecke": "Gelöschte Grundstücke",
  "GemaessGrundbuch": "Gemäss Grundbuch",
  "Gemeinde": "Gemeinde",
  "Gemeinde.Kuerzel": "Kürzel",
  "GemeindeAuswahl": "Gemeinde Auswahl",
  "GemeindeEntfernen": "Gemeinde entfernen",
  "GemeindeMussVorhandenSein": "Eine Gemeinde muss eingegeben werden",
  "Gemeinden": "Gemeinden",
  "Geogeschäfte": "Geometergeschäfte",
  "Geometergeschaeft.detail.VermarkungZurueckgestellt": "Vermarkung Zurückgestellt",
  "GeometergeschaeftNummer": "Geometergeschäfts Nummer",
  "Geometergeschaefte": "Geometergeschäfte",
  "Geometergeschaeftszustand.BEARBEITUNG": "In Bearbeitung",
  "Geometergeschaeftszustand.BEREIT_FUER_GRUNDBUCH": "Bereit für Grundbuch",
  "Geometergeschaeftszustand.BEREIT_FUER_KORREKTURLIEFERUNG": "Bereit für Korrektur",
  "Geometergeschaeftszustand.BEREIT_FUER_VERARBEITUNG": "Bereit für Verarbeitung",
  "Geometergeschaeftszustand.BEREIT_ZUR_VERIFIKATION": "Bereit zur Verifikation",
  "Geometergeschaeftszustand.EROEFFNET": "Eröffnet",
  "Geometergeschaeftszustand.RECHTSGUELTIG_ABGESCHLOSSEN": "Rechtsgültig abgeschlossen",
  "Geometergeschaeftszustand.RECHTSGUELTIG_VOLLZOGEN": "Rechtsgültig vollzogen",
  "Geometergeschaeftszustand.RUECKMUTIERT_ABGESCHLOSSEN": "Rückmutiert abgeschlossen",
  "Geometergeschaeftszustand.VERKNUEPFT_MIT_GRUNDBUCH": "Verknüpft mit Grundbuch",
  "Geometergeschaeftszustand.WARTEN_AUF_VORGAENGER": "Warten auf Vorgängergeschäft",
  "Geometergeschaeftszustand.ZURUECK_ABGEWIESEN": "Vom Grundbuch abgewiesen",
  "Geometergeschaeftszustand.ZURUECK_ZURUECKGEZOGEN": "Vom Grundbuch zurückgezogen",
  "Geometergeschaeftszustand.ZURUECK_ZUR_KORREKTUR": "Zurück zur Korrektur",
  "Geometergeschäft": "Geometergeschäft",
  "Gesamteigentum": "Gesamteigentum",
  "Gesamtfläche": "Gesamtfläche",
  "Gesamtpreis": "Gesamtpreis",
  "Gesamtwert": "Gesamtwert",
  "Geschaeftdetails": "Geschäftdetails",
  "GeschichteAnzeigen": "Geschichte anzeigen",
  "Geschlecht": "Geschlecht",
  "GeschlossenAm": "Geschlossen am",
  "Geschäftsstatus": "Geschäftsstatus",
  "Geschäftstyp": "Geschäftstyp",
  "Gesellschaftsform": "Gesellschaftsform",
  "GesetzlichesPfandrecht": "Gesetzliches Pfandrecht",
  "GestrichenMit": "Gestrichen mit",
  "Glaeubiger": "Gläubiger/in",
  "GlaeubigerGlaeubigerinVon": "Glaeubiger/in von ",
  "Gläubiger": "Gläubiger/in",
  "Grundbuch": "Grundbuch",
  "GrundbuchMeldungZip": "GrundbuchMeldung.zip",
  "Grundbuchamt": "Grundbuchamt",
  "Grundbuchgemeinde": "Grundbuchgemeinde",
  "Grundbuchgeschaeft": "Grundbuchgeschäft",
  "Grundbuchgeschäft": "Grundbuchgeschäft",
  "Grundbuchgeschäfte": "Grundbuchgeschäfte",
  "GrundbuchmeldungZuTagebuch": "Grundbuchmeldung zu Tagebuch",
  "Grundbuchperson": "Grundbuchperson",
  "Grundbuchpläne": "Grundbuchpläne",
  "Grundbuchtyp": "Grundbuchtyp",
  "Grundgueterschaetzung": "Grundgüterschätzung",
  "Grundlast": "Grundlast",
  "Grundlasten": "Grundlasten",
  "Grundpfandrecht": "Grundpfandrecht",
  "Grundpfandrechtart": "Grundpfandrechtart",
  "Grundpfandrechte": "Grundpfandrechte",
  "Grundpfandrechtform": "Grundpfandrechtform",
  "Grundstueck": "Grundstück",
  "GrundstueckArt": "GrundstueckArt",
  "GrundstueckKopf.Label.Gemeinde": "Gemeinde (BFS-Nr.)",
  "GrundstueckMitAenderungen": "Grundstück mit Änderungen",
  "GrundstueckMitFolgendenBodenbedeckungen": "Grundstück mit folgenden Bodenbedeckungen",
  "GrundstueckNummer": "Grundstücksnummer",
  "Grundstueckbeschreibung": "Grundstücksbeschreibung",
  "Grundstuecke": "Grundstück(e)",
  "Grundstuecksart": "Grundstücksart",
  "Grundstück": "Grundstück",
  "GrundstückGrundstücke": "Grundstück(e)",
  "GrundstückKopie": "Kopie",
  "GrundstückPerson": "Grundstück/Person",
  "Grundstückbeschreibung": "Grundstücksbeschreibung",
  "Grundstücke": "Grundstücke",
  "Gruppe": "Gruppe",
  "Gueltig": "Gültig",
  "GueltigeDateiAuswaehlen": "Bitte wählen sie eine gültige Datei aus",
  "Gültig": "Gültig",
  "HAENGIGE": "Hängige",
  "HAUPTBUCH": "Hauptbuch",
  "HAUPTBUCH_ABGESCHLOSSEN": "Hauptbuch Abgeschlossen",
  "HEIME_MIT_UNTERKUNFT_PFLEGEDIENSTE_BETREUUNG": "Heime mit Unterkunft, Pflegedienste und/oder Betreuung",
  "HERRENLOS": "Herrenlos",
  "HOCHBAU": "Hochbau",
  "HOEHERES_BILDUNGSWESEN_FORSCHUNG": "Höheres Bildungswesen und Forschung",
  "HOMONYME": "Homonyme",
  "HOTELGEBAEUDE": "Hotelgebäude",
  "HOTELS_RESTAURANTS": "Hotels, Restaurants",
  "HUMUSIERT_ACKER_WIESE_WEIDE": "Acker, Wiese, Weide",
  "HUMUSIERT_GARTENANLAGE": "Gartenanlage",
  "HUMUSIERT_HOCH_FLACHMOOR": "Hoch-, Flachmoor",
  "HUMUSIERT_INTENSIVKULTUR_REBEN": "Intensivkultur Reben",
  "HUMUSIERT_INTENSIVKULTUR_UEBRIGE_INTENSIVKULTUR": "Übrige Intensivkultur",
  "HUMUSIERT_UEBRIGE_HUMUSIERTE": "Übrige humusierte Fläche",
  "HaengigeGeschaefte": "HaengigeGeschaefte",
  "HaengigeGeschaefteAufbereiten": "Hängige Geschäfte aufbereiten",
  "HaengigeGeschaefteAufträge": "Hängige Geschäfte/Aufträge",
  "Handelsangaben": "Handelsangaben",
  "Haus-Nr.": "Haus-Nr.",
  "Header": "Header",
  "Heimatort": "Heimatort",
  "Hinweis": "Hinweis",
  "HinweismeldungAuszuege": "Nur 20 Auszüge können auf einmal gedruckt werden",
  "Historisiert": "Historisiert",
  "Hängig": "Hängig",
  "HängigeAufträge": "Hängige Aufträge",
  "HängigeGbgeschäfte": "Hängige Grundbuchgeschäfte",
  "HängigeGeogeschäfte": "Hängige Geometergeschäfte",
  "HängigeGeschäfte": "Hängige Geschäfte",
  "ID-DatumOderBelegOderRechtsgrund": "ID, Datum/Beleg/Rechtsgrund",
  "IMARBEIT": "Laufend",
  "IM_BAU": "Im Bau",
  "INDUSTRIEGEBAEUDE": "Industriegebäude",
  "INEINGETRAGENERPARTNERSCHAFT": "In eingetragener Partnerschaft",
  "INHABER": "Inhaber",
  "INHABER_PFANDRECHT_ART": "Inhaber-{{pfandrechtArt}}",
  "INHABER_PFANDRECHT_ART_PAPIER": "Inhaber-Papier-{{pfandrechtArt}}",
  "IcpPrintException": "Bei der Aufbereitung des Auszuges ist ein unerwarteter Fehler aufgetreten",
  "InEinemDokumentDrucken": "In einem Dokument drucken",
  "Index": "Index",
  "Index1-2": "Index 1-2",
  "Index1-3": "Index 1-3",
  "Inhalt": "Inhalt",
  "JA": "Ja",
  "JURISTISCHE_PERSON": "Juristische Person",
  "Ja": "Ja",
  "JaAmDatumDurchAnmelder": "Ja. Am {{datum}} durch {{anmelder}}",
  "Jahr": "Jahr",
  "JuristischePerson": "Juristische Person",
  "KANTONAL": "Kantonal",
  "KANTONSSTRASSEN": "Kantonsstrassen",
  "KAUFHAEUSER_GESCHAEFTSGEBAEUDE": "Kaufhäuser, Geschäftsgebäude",
  "KEHRICHTENTSORGUNGSANLAGEN": "Kehrichtentsorgungsanlagen",
  "KENNZEICHNUNG_GEO_GESCHAEFT": "Geometergeschäft",
  "KIRCHEN_SAKRALBAUTEN": "Kirchen und Sakralbauten",
  "KIRCHEN_UND_SONSTIGE_KULTGEBAEUDE": "Kirchen und sonstige Kultgebäude",
  "KOMMUNIKATIONSANLAGEN": "Kommunikationsanlagen",
  "KONZESSION": "Konzession",
  "KRANKENHAEUSER_UND_FACHEINRICHTUNGEN_DES_GESUNDHEITSWESENS": "Krankenhäuser und Facheinrichtungen des Gesundheitswesens",
  "KULTURBAUTEN_MUSEEN_BIBLIOTHEKEN_DENKMAELER": "Kulturbauten inkl. Museen, Bibliotheken und Denkmäler",
  "KantGid": "Kant-GID",
  "KantonalePersonenID": "Kantonale Personen-ID",
  "Katasternummer": "Katasternummer",
  "Keine": "Keine",
  "KeineBerechtigungFuer": "Keine Berechtigung für {{inputField}}",
  "KeineBerechtigungFürDieseAktion": "Sie haben keine Berechtigung für diese Aktion.",
  "KeineBzwGemaessGrundbuch": "Keine bzw. gemäss Grundbuch",
  "KeineDatenVorhanden": "Keine Daten vorhanden",
  "KeineResultateGefunden": "Es wurden keine entsprechenden Einträge gefunden.",
  "Komponenten": "Komponenten",
  "KuecheVorhanden": "Küche vorhanden",
  "Kuhrechte": "Bestand Kuhrechte",
  "Kurzbeschreibung": "Kurzbeschreibung",
  "KurzdeklarationBeilage": "Kurzdeklaration als Beilage",
  "LAGEFIXPUNKT": "Lagefixpunkt",
  "LAGERHALLEN_DEPOTS_SILOS_ZISTERNEN": "Lagerhallen, Depots, Silos und Zisternen",
  "LANDESVERTEIDIGUNGSBAUTEN": "Landesverteidigungsbauten",
  "LANDUMLEGUNG": "Landumlegung",
  "LANDWIRTSCHAFTLICHE_BETRIEBSGEBAEUDE": "Landwirtschaftliche Betriebsgebäude",
  "LANDWIRTSCHAFTSBAUTEN": "Landwirtschaftsbauten",
  "LEDIG": "Ledig",
  "LEEREPFANDSTELLE": "Leere Pfandstelle",
  "LIEGENSCHAFT": "Liegenschaft",
  "LIEGENSCHAFT_ausg": "Liegenschaft",
  "LIG": "LIG",
  "LR": "LR",
  "LageAufStockwerk": "Lage auf dem Stockwerk",
  "LageStockwerk": "Lage auf Stockwerk",
  "Lagebezeichnung": "Lagebezeichnung",
  "Last": "Last",
  "LastRechtAbkürzung": "LR",
  "LastetAuf": "Lastet auf",
  "Ledigname": "Ledigname",
  "LetzterEntgeltlicherErwerb": "LetzterEntgeltlicherErwerb",
  "Liegenschaft": "Liegenschaft",
  "Link": "Link",
  "Loading": "Die Daten werden geladen...",
  "Loeschbeleg": "L",
  "Login": "Login",
  "Logout": "Logout",
  "Löschen": "Löschen",
  "Löschgeschäft": "Löschgeschäft",
  "MAENNLICH": "Männlich",
  "MEHRFAMILIENHAEUSER": "Mehrfamilienhäuser",
  "MEHRFAMILIENHAEUSER_REINE_WOHNGEBAEUDE_MIT_MEHREREN_WOHNUNGEN": "Mehrfamilienhäuser (reine Wohngebäude mit mehreren Wohnungen)",
  "MELIORATIONEN": "Meliorationen",
  "MH": "MH",
  "MIT": "MIT",
  "MITEIGENTUM": "Miteigentumsanteil",
  "MITEIGENTUM_ausg": "Miteigentumsanteil",
  "MONATLICH": "Monatlich",
  "MUSEEN_BIBLIOTHEKEN": "Museen / Bibliotheken",
  "MarkiereAlsBearbeitet": "Markiere als bearbeitet",
  "MarkiereAlsNichtBearbeitet": "Markiere als nicht bearbeitet",
  "MaximalResultWarning": "Ergebnis unvollständig, da zu viele Einträge gefunden wurden. Bitte schränken Sie Ihre Suche ein. Die maximale Anzahl an Einträgen ist {{maxDisplayableRecords}}, gefunden wurden {{recordsFound}}.",
  "MaximalResultWarningKeineEinschraenkung": "Ergebnis unvollständig, da zu viele Einträge gefunden wurden. Die maximale Anzahl an Einträgen ist {{maxDisplayableRecords}}, gefunden wurden {{recordsFound}}.",
  "Maximalhypothek": "Maximalhypothek",
  "Maximalzinsfuss": "Maximalzinsfuss",
  "MehrAnzeigen": "Mehr anzeigen",
  "Mehrgeschossig": "Mehrgeschossig",
  "Meldung": "Meldung",
  "MeldungBearbeitet": "Meldung bearbeitet",
  "MeldungenAlsZip": "Alle als PDF exportieren (gezippt)",
  "MeldungsId": "Meldungs-ID",
  "Meldungsempfaenger": "Meldungsempfänger",
  "Mit": "mit",
  "MitAciIroleNr": "mit No ACI/IROLE",
  "MitAdresse": "mit Adresse",
  "MitGebäuden": "Mit Gebäuden",
  "MitGrundbuchbezug": "Mit Grundbuchbezug",
  "MitSonderrechten": "Mit Sonderrechten",
  "Miteigentumsanteil": "Miteigentumsanteil",
  "MizenNichtErreichbar": "Mitteilungszentrale konnte nicht erreicht werden (HTTP 401)",
  "Monat": "Monat",
  "Mutationsart": "Mutationsart",
  "NACHRUECK_RECHT": "Nachrückungsrecht",
  "NAMEN": "Namen",
  "NAMEN_PFANDRECHT_ART": "Namen-{{pfandrechtArt}}",
  "NAMEN_PFANDRECHT_ART_PAPIER": "Namen-Papier-{{pfandrechtArt}}",
  "NATIONALSTRASSEN": "Nationalstrassen",
  "NATUERLICHE_PERSON": "Natürliche Person",
  "NATURDENKMAL": "Naturdenkmal",
  "NB-Ident": "NB-Ident",
  "NEIN": "Nein",
  "NEUBAU": "Neubau",
  "NICHTBEARBEITET": "Nicht Bearbeitet",
  "NICHT_NUTZBAR": "Nicht nutzbar",
  "NICHT_REALISIERT": "Nicht realisiert",
  "NORMAL": "Normal",
  "NUTZNIESSER": "Nutzniesser/in",
  "Nachrueckungsrecht": "Nachrückungsrecht",
  "Nachrückungsrecht": "Nachrückungsrecht",
  "Name": "Name",
  "Name/Bezeichnung1": "Name / Bezeichnung 1",
  "NameDerEltern": "Name der Eltern",
  "NameEhegatte": "Name Ehepartner/in",
  "NameOderFirma": "Name/Firma",
  "Nationalitaet": "Nationalität",
  "NatuerlichePerson": "Natürliche Person",
  "Nein": "Nein",
  "NichtBearbeitet": "Nicht Bearbeitet",
  "NichtOeffentlicheBemerkung": "Nicht-öffentliche Bemerkung",
  "NonBreakingSpace": " ",
  "NotAvailable": "n/a",
  "NotEnoughChars": "NotEnoughChars",
  "Nummer": "Nummer",
  "NurOeffentlicheAnmerkungenWerdenAngezeigt": "Nur öffentliche Anmerkungen gemäss Art. 26 Abs. 1 c der Grundbuchverordnung. Weitere Rechte gemäss Grundbuch.",
  "NurZentraleId": "Nur zentrale ID",
  "OEFFENTLICHE_KOERPERSCHAFT": "Öffentlich-rechtliche Körperschaft",
  "ORTSNAME": "Ortsname",
  "Oberirdisch": "Oberirdisch",
  "Objekt-Nr.": "Objekt-Nr.",
  "Objektbezeichnung": "Objektbezeichnung",
  "Objektcode": "Objektcode",
  "OeffentlichRechtlicheKoerperschaft": "Öffentlich-rechtliche Körperschaft",
  "Oereb": "ÖREB-Kataster",
  "Ohne": "Ohne",
  "Ort": "Ort",
  "Ortschaft": "Ortschaft",
  "PARKHAEUSER": "Parkhäuser",
  "PARTERRE": "Parterre inkl. Hochparterre",
  "PERSONEN_GRUPPE": "Personengruppe",
  "PFANDOBLIGATION": "Pfandobligation",
  "PFANDRECHT": "Pfandrecht",
  "PFANDRECHT_BEMERKUNG": "Pfandrecht Bemerkung",
  "PFANDRECHT_KURZ": "PFR",
  "PROJEKT": "Projekt",
  "PROJEKTIERT": "Projektiert",
  "PROJEKT_ABGESCHLOSSEN": "Projekt abgeschlossen",
  "PROJEKT_BAUBEGONNEN": "Projekt baubegonnen",
  "PROJEKT_NICHT_REALISIERT": "Projekt nicht realisiert",
  "PROJEKT_SISTIERT": "Projekt sistiert",
  "PROJEKT_ZURUECKGEZOGEN": "Projekt zurückgezogen",
  "PROVISORISCH": "Provisorisch",
  "PROVISORISCHE_UNTERKUNFT": "Provisorische Unterkunft",
  "PROVISORISCH_ABGEWIESEN": "Provisorisch Abgewiesen",
  "Perimeter": "Perimeter",
  "Personalien": "Personalien",
  "Personart": "Personenart",
  "Personengruppe": "Personengruppe",
  "Personenregister": "Personenregister",
  "PersonstammVollstaendig": "Vollständig",
  "PfandrechtDetail": "Pfandrecht-Detail",
  "PfandrechtGläubiger": "Pfandrecht Gläubiger/in",
  "PfandrechtIdsAufbereiten": "Pfandrecht-IDs aufbereiten",
  "Pfandrechtbelastungen": "Pfandrechtbelastungen",
  "Pfandrechtgläubiger": "Pfandrechtgläubiger",
  "Pfandrechtschuldner": "Pfandrechtschuldner",
  "Pfandstelle": "Pfandstelle",
  "Pfandsumme": "Pfandsumme",
  "Pfandtitel": "Titel",
  "Plan": "Plan",
  "PlanZuGrundstueckAnzeigen": "Plan zu Grundstück {{param}} anzeigen",
  "PlzOderOrtschaft": "PLZ, Ortschaft",
  "PlzOrt": "PLZ/Ort",
  "Preis": "Preis",
  "ProjektAbgeschlossen": "Projekt abgeschlossen",
  "ProjektBaubegonnen": "Projekt baubegonnen",
  "ProjektNichtRealisiert": "Projekt nicht realisiert",
  "ProjektSistiert": "Projekt sistiert",
  "ProjektZurueckgezogen": "Projekt zurückgezogen",
  "Projektiert": "Projektiert",
  "ProjektiertStatus": "Projektiert-Status",
  "ProjektierteGebaeudeWohnungen": "Projektierte Gebäude / Wohnungen",
  "Projektmutation": "(Projektmutation)",
  "Projektstatus": "Projektstatus",
  "Projektumschreibung": "Projektumschreibung",
  "Protokollnummer": "Protokoll",
  "Publikationsdatum": "Publikationsdatum",
  "QUALITAET_FLAECHE": "Qualität Fläche",
  "QUELLENRECHT": "Quellenrecht",
  "QualitaetAV": "Qualitätsstandard AV",
  "QualitaetAV.AV93": "AV93",
  "QualitaetAV.GRAFISCH": "Grafisch",
  "QualitaetAV.PN": "PN",
  "QualitaetAV.PN_DEFINITIV": "PN definitiv anerkannt",
  "QualitaetAV.PN_PROVISORISCH": "PN provisorisch anerkannt",
  "QualitaetAV.UNVERMESSEN": "Unvermessen",
  "REBEN_BISHER": "Reben",
  "RECHNUNGSADRESSE": "Rechnungsadresse",
  "RECHTSDOMIZIL": "Rechtsdomizil",
  "RECHTSFORM": "Rechtsform",
  "RECHTSGRUND": "Rechtsgrund",
  "RECHTSGUELTIG": "Rechtsgültig",
  "RECHTSGUELTIG_ABGESCHLOSSEN": "Rechtsgültig abgeschlossen",
  "RECHTSGUELTIG_AUSGETRAGEN": "Rechtsgültig ausgetragen",
  "RECHTSGUELTIG_VOLLZOGEN": "Rechtsgültig vollzogen",
  "REFERENZADRESSE": "Referenzadresse",
  "REGISTERSCHULDBRIEF": "Register-Schuldbrief",
  "REKURS": "Rekurs",
  "REKURS_AKZEPTIERT": "RekursAkzeptiert",
  "RESTAURANTS_UND_BARS_IN_GEBAEUDEN_OHNE_WOHNNUTZUNG": "Restaurants und Bars in Gebäuden ohne Wohnnutzung",
  "RF": "RF",
  "RUECKMUTIERT_ABGESCHLOSSEN": "Rückmutiert abgeschlossen",
  "RUNDUNGSDIFFERENZ": "Rundungsdifferenz",
  "Recht": "Recht",
  "Rechtart": "Rechtart",
  "RechteId": "Rechte-ID",
  "Rechtsform": "Rechtsform",
  "Rechtsgrund": "Rechtsgrund",
  "RechtsgrundArt": "Art",
  "Rechtsgültig": "Rechtsgültig",
  "Region": "Region",
  "RegistraturText": "Registraturtext",
  "Renovationsjahr": "Renovationsjahr",
  "Rolle": "Rolle",
  "RolleGläubiger": "Rolle Gläubiger/in",
  "Rubrik": "Rubrik",
  "Rubriken": "Rubriken",
  "RueckmeldungGrundbuch": "Datum RückmeldungGB",
  "SCHIFFSVERKEHRSANLAGEN": "Schiffsverkehrsanlagen",
  "SCHULDBRIEF": "Schuldbrief",
  "SCHULDNER": "Schuldner/in",
  "SCHULDNER_ROLLE": "Schuldner",
  "SCHULEN_BILDUNGSWESEN_BIS_MATURASTUFE": "Schulen, Bildungswesen (bis Maturastufe)",
  "SCHUL_UND_HOCHSCHULGEBAEUDE_FORSCHUNGSEINRICHTUNGEN": "Schul- und Hochschulgebäude, Forschungseinrichtungen",
  "SCHWEIZERISCHE_JURISTISCHE_PERSON": "Schweizerisch-juristische Person",
  "SDR": "SDR",
  "SDR_DIENSTBARKEIT": "SDR Dienstbarkeit",
  "SDR_DIENSTBARKEIT_KURZ": "DI (SDR)",
  "SDR_ausg": "Selbstständiges und dauerndes Recht",
  "SEYBUCH": "Seybuch",
  "SONDERBAU": "Sonderbau",
  "SONSTIGE_HOCHBAUTEN": "Sonstige Hochbauten, anderweitig nicht genannt",
  "SPORTHALLEN": "Sporthallen",
  "SPORTHALLEN_SPORTPLAETZE": "Sporthallen und Sportplätze",
  "SPRACHE": "Sprache",
  "STANDARD": "Standard",
  "STOCK": "Stock",
  "STOCKWERK": "Stockwerkeigentum",
  "STOCKWERK_ausg": "Stockwerkeigentum",
  "STORNIERT": "Storniert",
  "STR": "STR",
  "STRASSE": "Strasse",
  "STRASSE_WEG_TROTTOIR_RAV": "Strasse, Weg, Trottoir, Verkehrsinsel",
  "STREITIGE_GRENZE": "Streitige Grenze",
  "STR_lang": "Strassenparzelle",
  "STW": "STW",
  "SUSPENDIERT": "Suspendiert",
  "Schliessen": "Schliessen",
  "SchnellSuche": "Schnellsuche",
  "Schuldner": "Schuldner/in",
  "SchuldnerSchuldnerinVon": "Schuldner/in von ",
  "SchulduebernahmeTotal": "Schuldübernahme total",
  "SelbststaendigUndDauerndeRechte": "Selbstständige und dauernde Rechte",
  "SelbststaendigesUndDauerndesRechtMitAbkuerzung": "Selbstständiges und dauerndes Recht (SDR)",
  "SelbstständigesUndDauerndesRecht": "Selbstständiges und dauerndes Recht",
  "Select date": "Datum Auswählen",
  "Servitute": "Servitute",
  "ServitutenregisterNr": "Servitutenregister-Nr",
  "Sitz": "Sitz",
  "SonderpreisZugabe": "Sonderpreis für Zugaben",
  "SonderpreisZugaben": "Sonderpreis für Zugaben",
  "Sonderrecht": "Sonderrecht",
  "Sonderrechte": "Sonderrechte",
  "Speichern": "Speichern",
  "Sprache": "Sprache",
  "Stammgrundstueck": "Stammgrundstück",
  "Stammperson": "Stammperson",
  "StammpersonImGrundbuch": "Stammperson im Grundbuch",
  "StandardSuche": "StandardSuche",
  "Standardrechtbelastungen": "Standardrechtbelastungen",
  "StandardrechteIdsAufbereiten_DI_GL_SDR_VO_AN": "Standardrechte-IDs aufbereiten (DI, GL, SDR, VO, AN)",
  "Standardsuche": " Standardsuche",
  "Startdatum": "Startdatum",
  "Status": "Status",
  "StehtAufFolgendenGrundstuecken": "Steht auf folgenden Grundstücken",
  "Steuerjahr": "Steuerjahr",
  "Stichwort": "Stichwort",
  "StichwortOderAblaufdatum": "Ablaufdatum/Stichwort",
  "Stichwortzusatz": "Stichwortzusatz",
  "Stockwerk": "Stockwerk",
  "Stockwerkeigentum": "Stockwerkeigentum",
  "Strasse": "Strasse",
  "StrasseBenanntesGebiet": "Strasse / benanntes Gebiet",
  "StrasseHausNr": "Strasse / Nr.",
  "StrasseOderFlurnameHausnummer": "Strasse, Haus-Nr.",
  "StrasseOderHausnummer": "Strasse, Haus-Nr.",
  "Suche": "Suche",
  "Suchergebnis": "Suchergebnis",
  "TAGEBUCH": "Tagebuch",
  "TAGEBUCH_ABGESCHLOSSEN": "Tagebuch Abgeschlossen",
  "TEILPFANDRECHT": "Teilpfandrecht",
  "TEILPFANDRECHT_KURZ": "T",
  "TIEFBAU": "Tiefbau",
  "TOPOMAPS": "Topomaps",
  "Tag": "Tag",
  "Tagebuchnummer": "Tagebuchnummer",
  "Tagebuchstatus": "Tagebuchstatus",
  "Teilbetrag": "Teilbetrag",
  "TeilbetragGruppe": "Teilbetrag Gruppe",
  "Teilflaeche": "Teilfläche",
  "Template": "Template",
  "TiteleingangGrundbuch": "Titeleingang Grundbuch",
  "Today": "Heute",
  "TodesdatumLiquidationsdatuminaktivSeit": "Todesdatum / Liquidationsdatum / inaktiv seit",
  "Totalflaeche": "Totalfläche",
  "Typ": "Typ",
  "TypDerBauwerke": "Typ der Bauwerke",
  "UEBRIGEART_lang": "Übrige",
  "UEBRIGER_STRASSENBAU_PARKPLAETZE": "Übriger Strassenbau, Parkplätze",
  "UEBRIGES_RECHT": "Weitere",
  "UEBRIGES_SPEZIALISIERTES_GESUNDHEITSWESEN": "Übriges spezialisiertes Gesundheitswesen",
  "UEBRIGE_BAUTEN_IM_ZUSAMMENHANG_MIT_WOHNGEBAEUDEN": "Übrige Bauten im Zusammenhang mit Wohngebäuden",
  "UEBRIGE_BERECHTIGTE": "Übrige Berechtigte",
  "UEBRIGE_ENTSORGUNGSANLAGEN": "Übrige Entsorgungsanlagen",
  "UEBRIGE_INFRASTRUKTUR": "Übrige Infrastruktur",
  "UEBRIGE_VERKEHRSANLAGEN": "Übrige Verkehrsanlagen",
  "UEBRIGE_VERSORGUNGSANLAGEN": "Übrige Versorgungsanlagen",
  "UEBRIGE_VERWENDUNG_FUER_WIRTSCHAFTLICHE_ZWECKE": "Übrige Verwendung für wirtschaftliche Zwecke",
  "UFERVERBAUUNGEN_STAUDAEMME": "Uferverbauungen, Staudämme",
  "UID": "UID",
  "UID_STATUS": "UID Status",
  "UMBAU": "Umbau",
  "UNB": "UNB",
  "UNBEKANNT": "Unbekannt",
  "UNBEKANNT_ausg": "Unbekannt",
  "UNBESTIMMT": "Unbestimmt",
  "UNKULTIVIERTES_GEBIET_BISHER": "Unkultiviertes Gebiet",
  "UNTERGESCHOSS": "Untergeschoss",
  "UNVERHEIRATET": "Unverheiratet",
  "UebernahmeGrundstueckgewinnsteuer": "Übernahme Grundstückgewinnsteuer durch Erwerber",
  "UebrigeBerechtigte": "Übrige Berechtigte",
  "UebrigeBerechtigungen": "Übrige Berechtigungen",
  "UidBeiNatuerlichenPersonenDrucken": "UID bei natürlichen Personen drucken",
  "UidStatus": "UidStatus",
  "Unterart": "Unterart",
  "Unterirdisch": "Unterirdisch",
  "Url": "Url",
  "User menu": "User menu",
  "VEC": "VEC",
  "VEC_lang": "Chemin de fer",
  "VEGETATIONSLOS_ABBAU_DEPONIE": "Abbau, Deponie",
  "VEGETATIONSLOS_FELS": "Fels",
  "VEGETATIONSLOS_GEROELL_SAND": "Geröll, Sand",
  "VEGETATIONSLOS_GLETSCHER_FIRN": "Gletscher, Firn",
  "VEGETATIONSLOS_UEBRIGE_VEGETATIONSLOSE": "Übrige vegetationslose Fläche",
  "VERAEUSSERER": "Veräusserer",
  "VERHEIRATET": "Verheiratet",
  "VERIFIKATION": "Verifikation",
  "VERKNUEPFT_MIT_GRUNDBUCH": "Verknüpft mit Grundbuch",
  "VERTRAGSART": "Vertragsart",
  "VERWALTERADRESSE": "Adresse Verwaltung",
  "VERWITWET": "Verwitwet",
  "VIC": "VIC",
  "VIC_lang": "Chemin vicinal",
  "VORBEHALTENERVORGANG": "Vorbehaltener Vorgang",
  "VORMERKUNG": "Vormerkung",
  "VORMERKUNG_KURZ": "VO",
  "VORPRUEFUNG": "Vorprüfung",
  "ValidierungsFehler": "Fehler bei der Validierung: {{fehlerMeldung}}",
  "Veraeusserer": "Veräusserer",
  "Verarbeitungsart": "Verarbeitungsart",
  "Verarbeitungsstatus": "Verarbeitungsstatus",
  "VerbindungZumServerNichtMöglich": "Die Verbindung zum Internet ist unterbrochen. Versuchen Sie mit F5 zu aktualisieren oder prüfen Sie Ihre Internet Verbindung.",
  "VergleichMitZpvPerson": "Vergleich mit ZPV-Person",
  "VersicherungsNr": "Versicherungs-Nr.",
  "VersicherungsNummerAbkürzung": "Vers-Nr.",
  "Versicherungsnummer": "Versicherungsnummer",
  "Vertragsart": "Vertragsart",
  "Vertragstexte": "Vertragstexte",
  "VertragstexteAufbereiten": "Vertragstexte aufbereiten",
  "VonAenderungenBetroffeneRubriken": "Von Änderungen betroffene Rubriken",
  "VoraussichtlicheBaudauer": "Voraussichtliche Baudauer",
  "Vormerkung": "Vormerkung",
  "Vormerkungen": "Vormerkungen",
  "Vorname": "Vorname",
  "Vorname/Bezeichnung2": "Vorname / Bezeichnung 2",
  "WALD_BISHER": "Wald",
  "WARTEN_AUF_VORGAENGER": "Warten auf Vorgängergeschäft",
  "WASSERENTSORGUNGSANLAGEN": "Wasserentsorgungsanlagen",
  "WASSERVERSORGUNGSANLAGEN": "Wasserversorgungsanlagen",
  "WEIBLICH": "Weiblich",
  "WEIDEN_BISHER": "Weiden",
  "WEIDWALD_BISHER": "Weidwald",
  "WERKSTAETTEN_FABRIKGEBAEUDE": "Werkstätten, Fabrikgebäude",
  "WOECHENTLICH": "Wöchentlich",
  "WOHNADRESSE": "Wohnadresse",
  "WOHNGEBAEUDE_FUER_GEMEINSCHAFTEN": "Wohngebäude für Gemeinschaften",
  "WOHNGEBAEUDE_MIT_NEBENNUTZUNG_BAUERNHAEUSER": "Wohngebäude mit Nebennutzung (inkl. Bauernhäuser)",
  "WOHNHEIME_OHNE_PFLEGEDIENSTE_BETREUUNG": "Wohnheime ohne Pflegedienste und/oder Betreuung",
  "WYTWEIDE_UEBRIGE_BESTOCKTE": "Wytweide, übrige bestockte Fläche",
  "Weiter": "Weiter",
  "WeitereBauprojektdaten": "Weitere Bauprojektdaten",
  "WeitereRechtsgründeAufbereiten": "Weitere Rechtsgründe aufbereiten",
  "WeitereVornamen": "Weitere Vornamen",
  "WenigerAnzeigen": "Weniger anzeigen",
  "Wertquote": "Wertquote",
  "Wohnungen": "Wohnungen",
  "Wohnungsflaeche": "Wohnungsfläche",
  "Wohnungsnummer": "Wohnungsnummer",
  "Wohnungsstatus": "Status",
  "XML": "XML",
  "XML_HTML": "XML-HTML",
  "ZPV-person": "ZPV-Person",
  "ZPVNummer": "ZPV-Nummer",
  "ZURUECKGEZOGEN": "Zurückgezogen",
  "ZURUECKGEZOGEN_AUSGETRAGEN": "Zurückgezogen Ausgetragen",
  "ZURUECK_ABGEWIESEN": "Vom Grundbuch abgewiesen",
  "ZURUECK_ZURUECKGEZOGEN": "Vom Grundbuch zurückgezogen",
  "ZURUECK_ZUR_KORREKTUR": "Zurück zur Korrektur",
  "ZUSTELLADRESSE": "Zustelladresse",
  "Zeilen": "Zeilen",
  "ZeitraumBis": "Zeitraum bis",
  "ZeitraumVon": "Zeitraum von",
  "ZinsUndAbzahlungsbestimmungen": "Spezielle Zins- und Abzahlungsbestimmungen",
  "Zivilstand": "Zivilstand",
  "ZuExportierendeGrundstuecke": "Zu exportierende Grundstücke",
  "ZuGunsten": "z.G.",
  "ZuGunstenLasten": "LR",
  "ZuLasten": "z.L.",
  "ZuVieleRequests": "Sie haben zu viele Anfragen gestellt. Bitte versuchen Sie es in einer Minute wieder.",
  "ZuVieleRequestsHeute": "Sie haben die Anzahl zulässiger Abfragen für heute erreicht. Versuchen Sie es morgen wieder",
  "Zuklappen": "zuklappen",
  "Zurück": "Zurück",
  "ZurückZumInhalt": "Zurück zum Inhalt",
  "Zurücksetzen": "Zurücksetzen",
  "Zusatzangaben": "Zusatzangaben",
  "Zustand": "Zustand",
  "actionbar.reset": "Zurücksetzen",
  "actionbar.search": "Suchen",
  "aktenempfaenger": "Aktenempfänger",
  "aktualisierungsdatum": "Aktualisierungsdatum",
  "alte-grunbbuchmeldungen.datenbestandBisUndMit": "Datenbestand enthält Meldungen bis und mit 30. September 2009",
  "alte-grundbuchmeldung.ListTitel": "Gefundene alte Meldungen",
  "alte-grundbuchmeldung.SucheTitel": "Suche nach alten Meldungen",
  "altegrundbuchmeldung.search.breadcrumb": "Alte Grundbuchmeldungen",
  "amtlicheBewertung": "Amtliche Bewertung",
  "an": "an ",
  "anonymous": "anonymous",
  "anschrift": "Anschrift",
  "atLeast2Letters": "Mindestens zwei Zeichen benötigt.",
  "auf": "auf",
  "auftrag.ListTitel": "Gefundene Aufträge",
  "auftraggeber": "Auftraggeber",
  "auftragsTyp": "auftragsTyp",
  "auszugAmtlicheBewertungComponent": "Amtliche Bewertung",
  "auszugAnmerkungenComponent": "Anmerkungen",
  "auszugDienstbarkeitenComponent": "Dienstbarkeiten",
  "auszugDienstbarkeitenPlaceHolderComponent": "Dienstbarkeiten",
  "auszugDominierteGrundstueckeComponent": "Dominierte Grundstücke",
  "auszugEigentumComponent": "Eigentum",
  "auszugGemeindeGrundstueckComponent": "Gemeinde Informationen",
  "auszugGrundbuchUebersichtComponent": "Grundbuchübersicht",
  "auszugGrundbuchUebersichtMiteigentumComponent": "Grundbuchübersicht Miteigentum",
  "auszugGrundbuchUebersichtStockwerkComponent": "Grundbuchübersicht Stockwerkeigentum",
  "auszugGrundbuchVertragstexteComponent": "Vertragstexte",
  "auszugGrundlastenComponent": "Grundlasten",
  "auszugGrundstueckBeschreibungLiegenschaftComponent": "Grundstücksbeschreibung",
  "auszugGrundstueckBeschreibungMiteigentumComponent": "Grundstücksbeschreibung",
  "auszugGrundstueckBeschreibungSDRComponent": "Grundstücksbeschreibung",
  "auszugGrundstueckBeschreibungStockwerkComponent": "Grundstücksbeschreibung",
  "auszugGwrComponent": "auszugGwrComponent",
  "auszugHaengigeGeschaefteGrundbuchComponent": "Hängige Geschäfte",
  "auszugOerebComponent": "ÖREB-Kataster",
  "auszugOerebPlaceHolderComponent": "ÖREB-Kataster",
  "auszugPfandrechteComponent": "Pfandrechte",
  "auszugRangregelungenComponent": "Rangregelungen",
  "auszugSeybuchAlpgrundstueckeComponent": "Alp Grundstücke",
  "auszugSeybuchGrundbuchDaten": "Alp Grundbuchdaten",
  "auszugSeybuchGrundstueckBeschreibung": "Grundstücksbeschreibung",
  "auszugVermessungUebersichtLiegenschaftComponent": "Vermessungsübersicht Liegenschaft",
  "auszugVermessungUebersichtSDRComponent": "Vermessungsübersicht SDR",
  "auszugVormerkungenComponent": "Vormerkungen",
  "avMutationsNummer": "Mutations Nummer",
  "backToIntercapi": "Zurück zu {{name}}",
  "batch.auftrag.delete.message": "den Auftrag",
  "batchauftrag.detail.Titel": "Stapelverarbeitungs-Auftrag: ",
  "bearbeitetstatusHeading": "Bearbeitungsstatus",
  "belegeZu": "Belege zu ",
  "berechtigtePersonen": "berechtigte Personen",
  "bfsNummer": "BFS-Nummer",
  "bis": "bis",
  "breadcrumbauskunftgrundbuchmeldung": "Grundbuchmeldungen",
  "breadcrumbauskunftgrundbuchmeldunglist": "Suchergebnis",
  "cantSearchAlone": "Dieses Feld kann nicht alleine gesucht werden",
  "cmisModal.fensterSchliessen": "Fenster schliessen",
  "component.tablewrapper.nichtVollstaendigGeladen": "Achtung, nicht alle Daten sind geladen.",
  "component.tablewrapper.resume": "Laden",
  "component.tablewrapper.suspend": "Pause",
  "configuration.actions": "Aktionen",
  "configuration.cancel": "Abbrechen",
  "configuration.deutscherLink": "URL DE",
  "configuration.deutscherName": "Name DE",
  "configuration.download": "Download",
  "configuration.dropZone": "Drop Zone",
  "configuration.fileAuswaehlen": "Datei auswählen",
  "configuration.franzoesischerLink": "URL FR",
  "configuration.franzoesischerName": "Name FR",
  "configuration.konfigurationDerAnsicht": "Konfiguration der Ansicht",
  "configuration.konfigurationHeraufladen": "Konfiguration Heraufladen",
  "configuration.konfigurationHerunterladen": "Konfiguration Herunterladen",
  "configuration.konfigurationVerwalten": "Konfiguration verwalten",
  "configuration.linksImMenuUnterstuetzung": "Links im Menu Information",
  "configuration.linksImMenuUnterstuetzungPublic": "Links im Menu Information (Intercapi-Public)",
  "configuration.name": "Name",
  "configuration.position": "Position",
  "configuration.progress": "Fortschritt",
  "configuration.queueLength": "Länge",
  "configuration.reihenfolgeGrundstueckdetail": "Reihenfolge Grundstückdetail",
  "configuration.reihenfolgePfandrechtdetail": "Reihenfolge Pfandrechtdetail",
  "configuration.reihenfolgeStandardrechtdetail": "Reihenfolge Standardrechtdetail",
  "configuration.remove": "Entfernen",
  "configuration.size": "Grösse",
  "configuration.status": "Status",
  "configuration.titel": "Titel",
  "configuration.upload": "Upload",
  "configuration.uploadQueue": "Warteschlange",
  "core.navigation.abmelden": "Abmelden",
  "core.navigation.altegrundbuchmeldung": "Alte Grundbuchmeldungen",
  "core.navigation.amtlicheBewertung": "Amtliche Bewertung",
  "core.navigation.berechtigtePersonen": "Berechtigte Personen",
  "core.navigation.ech0134.empfaenger": "eCH-Meldungsempfänger/in",
  "core.navigation.ech0134.grundbuchmeldungen": "eCH-Grundbuchmeldungen",
  "core.navigation.erweitertesSuchregister": "Eigentümerliste BE",
  "core.navigation.gebaeude": "Gebäude",
  "core.navigation.gebaeudeUndWohnungsregister": "Gebäude- und Wohnungsregister (GWR)",
  "core.navigation.gemeindeGemeindekreis": "Gemeinde / Gemeindekreis",
  "core.navigation.geometergeschaeft": "Geometergeschäft",
  "core.navigation.glossar": "Glossar",
  "core.navigation.grundbuch": "Grundbuch",
  "core.navigation.grundbuchgeschaeft": "Grundbuchgeschäfte",
  "core.navigation.grundbuchmeldung": "Grundbuchmeldungen",
  "core.navigation.grundstueck": "Grundstück",
  "core.navigation.gwrBauprojekte": "GWR-Bauprojekte",
  "core.navigation.gwrGebaeude": "GWR-Gebäude",
  "core.navigation.home": "Home",
  "core.navigation.importExport": "Import / Export",
  "core.navigation.impressumRechtliches": "Impressum und Rechtliches",
  "core.navigation.konfiguration": "Konfiguration",
  "core.navigation.meineGrundstueckePublic": "Meine Grundstücke",
  "core.navigation.meineGrundstueckePublic.identifizierungsStufeUnzureichend": "Sie verfügen nicht über die nötige Identifizierungsstufe, um die Daten einsehen zu dürfen.",
  "core.navigation.meineGrundstueckePublic.stepUpRegistrierung": "Bitte registrieren Sie sich unter",
  "core.navigation.meineGrundstueckePublic.stepUpRegistrierungLinkText": "Upgrade Identifizierungsstufe",
  "core.navigation.neskoab": "NESKOAB",
  "core.navigation.publikation": "Publikationen",
  "core.navigation.rechte": "Rechte",
  "core.navigation.stammdaten": "Stammdaten",
  "core.navigation.stammpersonen": "Stammperson",
  "core.navigation.system": "System",
  "core.navigation.unterstuetzung": "Information",
  "core.navigation.unterstuetzungPublic": "Information",
  "core.navigation.vermessung": "Vermessung",
  "dashboard.rechtehinweis.legalHintComment": "Verbindlich sind einzig die vom zuständigen Amt respektive der zuständigen Behörde ausgestellten und beglaubigten Registerauszüge.",
  "dashboard.rechtehinweis.legalHintComment1": " ",
  "dashboard.rechtehinweis.legalHintHeader": "Hinweis: Rechtsgültigkeit der Daten",
  "dashboard.rechtehinweis.legalHintMessage": "Die dargestellten Daten und Verweise sind ohne Gewähr und haben keinerlei Rechtswirkung.",
  "datenexport.BODENBEDECKUNGSFILTER": "Standard Grundstückexport - Bodenbedeckungsfilter",
  "datenexport.EIGENTUEMERART": "Standard Grundstückexport - Eigentümerart",
  "datenexport.EIGENTUEMERLISTE": "Standard Grundstückexport - Eigentümerliste",
  "datenexport.EIGENTUEMERREGISTER": "Standard Grundstückexport - Eigentümerregister",
  "datenexport.GEAENDERTEBODENBEDGS": "Standard Grundstückexport - geänderte Grundstücke mit Einschränkung auf Bodenbedeckung",
  "datenexport.GEAENDERTEGS": "Standard Grundstückexport - geänderte Grundstücke",
  "datenexport.GEBAEUDELISTE": "Standard Grundstückexport - Gebäudeliste",
  "datenexport.GELAN": "GELAN",
  "datenexport.GELOESCHTBODENBEDGS": "Standard Grundstückexport - gelöschte Grundstücke mit Einschränkung auf Bodenbedeckung",
  "datenexport.GELOESCHTEGS": "Standard Grundstückexport - gelöschte Grundstücke",
  "datenexport.GRUNDSTUECKLISTE": "Standard Grundstückexport - Grundstückliste",
  "datenexport.RECHTEREGISTER": "Rechteregister",
  "datenexport.STANDARD": "Standard Grundstückexport",
  "datenexport.auftrag": "Auftrag",
  "datenexport.auftragstitelUndBeschreibung": "Auftragstitel und -beschreibung",
  "datenexport.ausfuehrungsdatum": "Ausführungsdatum",
  "datenexport.auswahlAuftragsexportTemplate": "Auswahl Auftragstyp-Template",
  "datenexport.auswahlAuftragsoptionen": "Auswahl der Auftragsoptionen",
  "datenexport.auswahlAuftragsoptionen_readonly": "Ausgewählte Auftragsoptionen",
  "datenexport.auswahlAuftragstyp": "Auswahl Auftragstyp",
  "datenexport.auswahlAuftragstyp_readonly": "Ausgewählter Auftragstyp",
  "datenexport.auswahlBetroffenerDatenbestand": "Auswahl des betroffenen Datenbestandes",
  "datenexport.auswahlBetroffenerDatenbestand_readonly": "Ausgewählter Datenbestand",
  "datenexport.auswahlErgebnisoptionen": "Auswahl der Ergebnisoptionen",
  "datenexport.auswahlErgebnisoptionen_readonly": "Ausgewählte Ergebnisoptionen",
  "datenexport.beschreibung": "Beschreibung",
  "datenexport.detailsZumAuftraggeber": "Details zum Auftraggeber",
  "datenexport.email1": "Email 1",
  "datenexport.email2": "Email 2",
  "datenexport.email3": "Email 3",
  "datenexport.format": "Format",
  "datenexport.informationAnFolgendeEmpfaenger": "Information an folgende Empfänger (max. 3)",
  "datenexport.periodizitaet": "Periodizität",
  "datenexport.periodizitaetValues": "datenexport.periodizitaetValues",
  "datenexport.prioritaet": "Priorität",
  "datenexport.prioritaetValues": "datenexport.prioritaetValues",
  "datenexport.stapelverarbeitungsauftragErstellen": "Stapelverarbeitungsauftrag erstellen",
  "datenexport.titel": "Titel",
  "delete.check.modal.body": "Wollen Sie '{{entity}}' wirklich löschen?",
  "delete.check.modal.title": "Löschen",
  "detailGrundstueckAnmerkungen": "Anmerkungen",
  "detailGrundstueckBeschreibung": "Grundstückbeschreibung",
  "detailGrundstueckDienstbarkeiten": "Dienstbarkeiten",
  "detailGrundstueckEigentum": "Eigentum",
  "detailGrundstueckGeschaefteAuftraege": "Geschäfte / Aufträge",
  "detailGrundstueckGrundlasten": "Grundlasten",
  "detailGrundstueckGrundpfandrechte": "Grundpfandrechte",
  "detailGrundstueckRangregelungen": "Rangregelungen",
  "detailGrundstueckVormerkungen": "Vormerkungen",
  "detailPfandrechtBelastungen": "Belastungen",
  "detailPfandrechtGlaeubiger": "Gläubiger/in",
  "detailPfandrechtHaengigeGeschaefte": "Hängige Geschäfte",
  "detailPfandrechtKopfdaten": "Kopfdaten",
  "detailPfandrechtPerimeter": "Perimeter",
  "detailPfandrechtPfandtitel": "Pfandtitel",
  "detailPfandrechtSchuldner": "Schuldner/in",
  "detailStandardrechtBelastungen": "Belastungen",
  "detailStandardrechtHaengigeGeschaefte": "Hängige Geschäfte",
  "detailStandardrechtKopfdaten": "Kopfdaten",
  "detailStandardrechtPerimeter": "Perimeter",
  "detailsGemeindeGb": "Details zu Gemeinde {{name}} anzeigen",
  "detailsGeometerGeschäft": "Details zu Geometergeschäft anzeigen",
  "detailsGeschäft": "Details zu Geschäft anzeigen",
  "detailsGrundstueck": "Details zu Grundstück {{nummer}}",
  "detailsMutationAnzeigen": "Details zu AV-Mutationen anzeigen",
  "dirty.check.modal.body": "Wollen Sie die Seite wirklich verlassen?",
  "dirty.check.modal.title": "Ungespeicherte Daten",
  "dokulinkModal.fensterSchliessen": "Fenster schliessen",
  "durch": "durch",
  "eBelege": "eBelege",
  "ech0134.grundbuchmeldung.list": "Gefundene eCH-Grundbuchmeldungen",
  "ech0134.grundbuchmeldungen.datumVersandBis": "Versanddatum bis",
  "ech0134.grundbuchmeldungen.datumVersandVon": "Versanddatum von",
  "ech0134.grundbuchmeldungen.delete": "eCH-Grundbuchmeldungen löschen",
  "ech0134.grundbuchmeldungen.empfaenger": "eCH-Meldungsempfänger/in",
  "ech0134.grundbuchmeldungen.reset.message": "eCH-Grundbuchmeldung {{geschaeftsnummer}} an Empfänger/in {{sedexId}}",
  "ech0134.grundbuchmeldungen.status": "Meldungsstatus",
  "ech0134.grundbuchmeldungen.suche": "Suche nach eCH-Grundbuchmeldungen",
  "ech0134.grundbuchmeldungen.title": "eCH-Grundbuchmeldungen",
  "egbpid.gehoertZuStammperson": "Die eingegebene EGBPID gehört zur folgenden Stammperson:",
  "egbpid.navigationTitel": "Stammperson anzeigen?",
  "egbpid.stammpersonAnzeigen": "Wollen Sie die Stammperson anzeigen?",
  "eigentuemerAdressliste.egridList": "E-GRID Liste",
  "eigentuemerAdressliste.eigentuemerAdressliste": "Eigentümeradressliste",
  "eigentuemerAdressliste.infoEigentuemerAdressliste": "Aus der E-GRID Nummerliste wird eine Eigentümeradressliste generiert",
  "eigentuemerAdressliste.infoKommaTrennung": "Die E-GRID Nummerliste muss mit Kommas getrennt werden",
  "eigentuemerAdressliste.infoMizen": "Die Eigentümeradressliste wird in Mizen zur Verfügung stehen",
  "eigentuemerAdressliste.listeErstellen": "Liste erstellen",
  "eigentuemerAdressliste.mizen": "Eine Liste mit den Eigentümeradresslisten wird erstellt. Die Liste wird nach Mizen geschickt.",
  "eigentumImGrundbuch": "Eigentum im Grundbuch",
  "eigentumanteil.anteilUnbekannt": "Anteil unbekannt",
  "eigentumanteil.unbekannt": "Unbekannt",
  "eintragungAmtlicheBewertung": "Eintragungen in der Amtlichen Bewertung",
  "elasticsearch.options": "Suchoptionen",
  "email": "E-Mail",
  "erweitern": "erweitern",
  "erweitertesSuchregister.MitGebaeude": "Mit Gebäuden",
  "erweitertesSuchregister.infoMessage": "Erstellt eine Liste mit Grundstücken, bei welchen der Kanton Bern als Eigentümer eingetragen ist. Die Erstellung kann mehrere Minuten dauern.",
  "externeGemeinde": "Externe Gemeinde",
  "false": "Nein",
  "forbidden.text": "Sie sind für folgende Aktion nicht berechtigt.",
  "forbidden.title": "Zugriff verweigert",
  "functionbar.back": "Zurück",
  "functionbar.cancel": "Abbrechen",
  "functionbar.continue": "Fortsetzen",
  "functionbar.delete": "Löschen",
  "functionbar.edit": "Editieren",
  "functionbar.new": "Neu",
  "functionbar.save": "Speichern",
  "gebaeude.BE-GID": "BE-GID",
  "gebaeude.BreadcrumbSuche": "Gebäude",
  "gebaeude.Egid": "EGID",
  "gebaeude.EgidKantGid": "EGID / Kant-GID",
  "gebaeude.KantonalerGid": "Kantonaler GID",
  "gebaeude.SucheTitel": "Suche nach Gebäuden",
  "gebaeude.gehoertZuSDR": "gehört zu SDR",
  "gebaeudeart": "Gebäudeart",
  "gebauede.gehoertZuSDR": "gebauede.gehoertZuSDR",
  "geburtsdatumInZukunft": "Das Geburtsdatum liegt in der Zukunft.",
  "gebäudeeingangHeading": "Gebäudeeingang",
  "gefundeneGemeinden": "Gefundene Gemeinden",
  "gefundeneGeometergeschaefte": "Gefundene Geometergeschäfte",
  "gefundeneGrundbuchgeschaefte": "Gefundene Grundbuchgeschäfte",
  "gegeneintraegeDITDienstbarkeitenDrucken": "Gegeneinträge *DI-/T-Dienstbarkeiten drucken",
  "gehoertZu": "gehört zu",
  "gehoertZuFolgenderPolitischerGemeinde": "Gehört zu folgender politischer Gemeinde",
  "gehoertZuGrundstueck": "Gehört zu folgendem Grundstück",
  "gemaessAmtlicherBewertung": "Gemäss amtlicher Bewertung",
  "gemaessGrundbuch": "gemäss Grundbuch",
  "gemaessZPV": "Gemäss ZPV",
  "gemeinde.SucheTitel": "Suche nach Gemeinden",
  "gemeinde.bfs": "BFS-Nr",
  "gemeinde.breadcumbSuche": "Gemeinde / Gemeindekreis",
  "gemeinde.kreis": "Kreisnummer",
  "gemeinde.name": "Name",
  "geometrischAuf": "geometrisch auf",
  "glaeubiger": "Gläubiger",
  "grundbuchmeldung.SucheTitel": "Suche nach Grundbuchmeldungen",
  "grundbuchmeldung.datummeldung": "Versanddatum",
  "grundbuchmeldung.download": "Meldungen herunterladen",
  "grundbuchmeldung.empfaenger.bezeichnung": "Empfängerbezeichnung",
  "grundbuchmeldung.meldungsstatus": "Meldungsstatus",
  "grundbuchmeldung.meldungsstatus.ERSTELLT": "Erstellt",
  "grundbuchmeldung.meldungsstatus.FEHLERHAFT_ERSTELLT": "Fehlerhaft Erstellt",
  "grundbuchmeldung.meldungsstatus.FEHLERHAFT_GESENDET": "Fehlerhaft Gesendet",
  "grundbuchmeldung.meldungsstatus.GESENDET": "Gesendet",
  "grundbuchmeldung.meldungsstatus.NICHT_ERSTELLT": "Nicht Erstellt",
  "grundbuchmeldung.reset": "Versand zurücksetzen",
  "grundbuchmeldung.search.breadcrumb": "Grundbuchmeldungen",
  "grundbuchmeldung.suche": "Suche",
  "grundbuchmeldung.tooltip": "Grundbuchmeldung anzeigen",
  "grundbuchmeldung_": "grundbuchmeldung_",
  "grundbuchmeldungen.ListTitel": "Gefundene Grundbuchmeldungen",
  "grundstueck.ListTitel": "Gefundene Grundstücke",
  "grundstueck.SucheTitel": "Suche nach Grundstücken",
  "grundstueck.eigentum.Bemerkungen": "Bemerkungen",
  "grundstueck.eigentum.DominierendesGrundstueck": "Dominierendes Grundstück",
  "grundstueck.eigentum.ExterneHinweise": "Externe Hinweise",
  "grundstueck.rubrik.AlleDaten": "Alle Grundstückdaten",
  "grundstueck.rubrik.Anmerkungen": "Anmerkungen",
  "grundstueck.rubrik.BeschreibendeDaten": "Grundstücksbeschreibung",
  "grundstueck.rubrik.Dienstbarkeiten": "Dienstbarkeiten",
  "grundstueck.rubrik.Eigentum": "Eigentum (gemäss Grundbuch)",
  "grundstueck.rubrik.Grundlasten": "Grundlasten",
  "grundstueck.rubrik.Grundpfandrechte": "Grundpfandrechte",
  "grundstueck.rubrik.Grundstueckbeschreibung": "Grundstücksbeschreibung",
  "grundstueck.rubrik.HaengigeGeschaefte": "Geschäfte",
  "grundstueck.rubrik.OeffentlicheAnmerkungen": "Öffentliche Anmerkungen",
  "grundstueck.rubrik.Oereb": "ÖREB-Kataster",
  "grundstueck.rubrik.Rangregelung": "Rangregelungen",
  "grundstueck.rubrik.Vormerkungen": "Vormerkungen",
  "grundstueck.search.breadcrumb": "Grundstück",
  "grundstueck.subnav.Anmerkungen": "Anmerkungen",
  "grundstueck.subnav.BeschreibendeDaten": "Beschreibende Daten",
  "grundstueck.subnav.Dienstbarkeiten": "Dienstbarkeiten",
  "grundstueck.subnav.Eigentum": "Eigentum",
  "grundstueck.subnav.GrundbuchVermessung": "Grundbuch/Vermessung",
  "grundstueck.subnav.Grundlasten": "Grundlasten",
  "grundstueck.subnav.Grundpfandrechte": "Grundpfandrechte",
  "grundstueck.subnav.GwrObjekte": "Gebäude- und Wohnungsregister",
  "grundstueck.subnav.HaengigeGeschaefte": "Geschäfte",
  "grundstueck.subnav.OerebKataster": "ÖREB-Kataster",
  "grundstueck.subnav.Rangregelungen": "Rangregelungen",
  "grundstueck.subnav.Uebersicht": "Übersicht",
  "grundstueck.subnav.Vormerkungen": "Vormerkungen",
  "grundstueck.subnav.neskoab": "Externe Amtliche Bewertung",
  "grundstueckHeading": "Grundstück",
  "grundstueckflaeche": "Grundstücksfläche",
  "gueltig": "Gültig",
  "gwr-link.tooltip": "Details zu  EGID {{egid}} in GWR anzeigen",
  "gwr.EingabeMussGueltigeStrasseSein": "Die Strasse darf maximal 60 Zeichen enthalten",
  "gwrBauprojekt.BreadcrumbSuche": "GWR-Bauprojekt",
  "gwrBauprojekt.SucheTitel": "Suche nach GWR-Bauprojekten",
  "gwrGebaeude.BreadcrumbSuche": "GWR-Gebäude",
  "gwrGebaeude.SucheTitel": "Suche nach GWR-Gebäuden",
  "gültigAbSteuerjahr": "gültig ab Steuerjahr",
  "handelsangabenZu": "Handelsangaben zu",
  "historisiert": "historisiert",
  "illegalObjectState": "illegalObjectState",
  "imNachgangZu": "im Nachgang zu:",
  "inbox.new-message": "Im Postfach befinden sich ungelesene Nachrichten",
  "inbox.notification.title": "Mitteilung in neues Fenster öffnen",
  "inbox.open": "Postfach öffnen",
  "inbox.open.title": "Postfach in neues Fenster öffnen",
  "inbox.title": "Postfach",
  "invalidrequest.title": "Ungültige Anfrage",
  "kanton": "Kanton",
  "kompakt": "kompakt",
  "kreisNummer": "Kreisnummer",
  "kuerzel": "Kürzel",
  "layouts.GeschichteEinAus": "Geschichte ein/aus",
  "layouts.emailAendern": "E-Mail ändern",
  "layouts.entwicklungsUmgebung": "Entwicklungsumgebung",
  "layouts.notAutorizedTitle": "Autorisierung fehlgeschlagen: Der angemeldete User ist in {{appTitle}} nicht zugelassen.",
  "layouts.page.title": "Intercapi",
  "layouts.page.titleNavigation": "Intercapi Navigation",
  "layouts.passwortAendern": "Passwort ändern",
  "layouts.settings": "Settings",
  "layouts.testUmgebung": "Testumgebung",
  "layouts.toolbar.de": "DE",
  "layouts.toolbar.fr": "FR",
  "maps.anzeigePlan": "Anzeige Plan",
  "maps.anzeigePlanZu": "Anzeige Plan zu",
  "maps.exception.errorPageTitle": "Fehler beim Kartenaufruf im Fremdystem {{fremdsystem}}.",
  "maps.exception.geo_link.allGrundstueckeNotFound": "Die gesuchten Grundstücke können momentan im Plan nicht angezeigt werden.",
  "maps.exception.geo_link.authorizationFailed": "Sie sind nicht berechtigt, diese Karte anzuzeigen. Bitte melden Sie sich bei Grudis an.",
  "maps.exception.geo_link.errorMessage": "Es ist ein technischer Fehler aufgetreten. Die Karte kann leider nicht angezeigt werden.",
  "maps.exception.geo_link.gemeindeNotFound": "Die Gemeinde/der Grundbuchkreis kann im Plan momentan nicht angezeigt werden.",
  "maps.exception.geo_link.grundstueckNotFound": "Das gesuchte Grundstück kann im Plan nicht angezeigt werden. Es sind keine digitalen Geometriedaten vorhanden. Wollen Sie den Plan der Gemeinde/des Grundbuchkreises anzeigen lassen?",
  "maps.exception.geo_link.invalidRequest": "Der Kartenaufruf ist ungültig. Falls dies wiederholt auftritt, kontaktieren Sie bitte ihren Administrator.",
  "maps.exception.topomaps.authorizationFailed": "Sie sind nicht berechtigt, diese Karte anzuzeigen. Bitte melden Sie sich bei Grudis an.",
  "maps.exception.topomaps.errorMessage": "Es ist ein technischer Fehler aufgetreten. Die Karte kann leider nicht angezeigt werden.",
  "maps.exception.topomaps.invalidRequest": "Der Kartenaufruf ist ungültig. Falls dies wiederholt auftritt, kontaktieren Sie bitte ihren Administrator.",
  "mehrereNachfuehrungsgeometer": "Zu dieser Gemeinde sind mehrere Nachführungsgeometer eingetragen, es kann aber nur einer angezeigt werden",
  "meinGrundstueck.tooltip": "Aufgrund Ihres Eigentums sind für Sie weitere Informationen zum Grundstück ersichtlich",
  "meineGrundstuecke.filter": "Grundstücke filtern",
  "meineGrundstuecke.titel": "Meine Grundstücke",
  "meldungAbschlussdatumHeading": "Abschlussdatum (Rechtsgültigsetzung)",
  "meldungEingangsdatumHeading": "Eingangsdatum Tagebuch",
  "meldungErwerberVeraeussererHeading": "Erwerbende Person/Veräussernde Person",
  "meldungGebaeudeHeading": "Gebäude",
  "meldungsempfaenger.bezeichnung": "Bezeichnung",
  "meldungsempfaenger.bezeichnung.invalid": "Bezeichnung darf nicht leer sein",
  "meldungsempfaenger.detail": "eCH-Meldungsempfänger/in",
  "meldungsempfaenger.ereignisse": "Erhält nur folgende Ereignisse",
  "meldungsempfaenger.ereignisse.AENDERUNG_ANMERKUNG": "Änderung Anmerkung",
  "meldungsempfaenger.ereignisse.AENDERUNG_DIENSTBARKEIT": "Änderung Dienstbarkeit",
  "meldungsempfaenger.ereignisse.AENDERUNG_EIGENTUM": "Änderung Eigentumsanteil",
  "meldungsempfaenger.ereignisse.AENDERUNG_GRUNDLAST": "Änderung Grundlast",
  "meldungsempfaenger.ereignisse.AENDERUNG_LIG_SDR": "Änderung Liegeschaft oder SDR",
  "meldungsempfaenger.ereignisse.AENDERUNG_PFANDRECHT": "Änderung Grundpfandrecht",
  "meldungsempfaenger.ereignisse.AENDERUNG_STW_MIT": "Änderung Miteigentumsanteil",
  "meldungsempfaenger.ereignisse.AENDERUNG_VORMERKUNG": "Änderung Vormerkung",
  "meldungsempfaenger.ereignisse.LOESCHUNG_ANMERKUNG": "Löschung Anmerkung",
  "meldungsempfaenger.ereignisse.LOESCHUNG_DIENSTBARKEIT": "Löschung Dienstbarkeit",
  "meldungsempfaenger.ereignisse.LOESCHUNG_EIGENTUM": "Löschung Eigentumsanteil",
  "meldungsempfaenger.ereignisse.LOESCHUNG_GRUNDLAST": "Löschung Grundlast",
  "meldungsempfaenger.ereignisse.LOESCHUNG_LIG_SDR": "Löschung Liegenschaft oder SDR",
  "meldungsempfaenger.ereignisse.LOESCHUNG_PFANDRECHT": "Löschung Grundpfandrecht",
  "meldungsempfaenger.ereignisse.LOESCHUNG_STW_MIT": "Löschung Miteigentumsanteil",
  "meldungsempfaenger.ereignisse.LOESCHUNG_VORMERKUNG": "Löschung Vormerkung",
  "meldungsempfaenger.ereignisse.NEU_ANMERKUNG": "Neue Anmerkung",
  "meldungsempfaenger.ereignisse.NEU_DIENSTBARKEIT": "Neue Dienstbarkeit",
  "meldungsempfaenger.ereignisse.NEU_EIGENTUM": "Neuer Eigentumsanteil",
  "meldungsempfaenger.ereignisse.NEU_GRUNDLAST": "Neue Grundlast",
  "meldungsempfaenger.ereignisse.NEU_LIG_SDR": "Neue Liegenschaft oder SDR",
  "meldungsempfaenger.ereignisse.NEU_PFANDRECHT": "Neues Grundpfandrecht",
  "meldungsempfaenger.ereignisse.NEU_STW_MIT": "Neuer Miteigentumsanteil",
  "meldungsempfaenger.ereignisse.NEU_VORMERKUNG": "Neue Vormerkung",
  "meldungsempfaenger.erhaeltBaseDelivery": "Erhält Basedelivery",
  "meldungsempfaenger.erhaeltVertraulicheDaten": "Erhält vertrauliche Daten",
  "meldungsempfaenger.erhaeltmeldungen": "Erhält Meldungen",
  "meldungsempfaenger.error.uniqueConstraint": "Es existiert bereits ein eCH-Meldungsempfänger/in mit dieser Empfänger-ID",
  "meldungsempfaenger.gemeinde": "Eingeschränkt auf folgende Gemeinden",
  "meldungsempfaenger.hasMeldungen": "Empfänger besitzt Meldungen. Löschen nicht erlaubt.",
  "meldungsempfaenger.list": "Gefundene eCH-Meldungsempfänger/innen",
  "meldungsempfaenger.sedexid": "Sedex-Empfänger-ID",
  "meldungsempfaenger.sedexid.invalid": "Sedex-Empfänger-ID ist ungültig",
  "meldungsempfaenger.suche": "eCH-Meldungsempfänger/in",
  "modal.close": "Schliessen",
  "monat": "Monat",
  "monate": "Monate",
  "navigation.grundbuchmeldung": "Grundbuchmeldung anzeigen",
  "neskoab.AmtlicheBewertung": "Amtliche Bewertung",
  "neskoab.AmtlicherWert": "Amtlicher Wert",
  "neskoab.AmtlicherWertCHF": "Amtlicher Wert CHF",
  "neskoab.BasisRevision": "Basis Revision",
  "neskoab.Eigentum/Verteiler": "Eigentum/Verteiler",
  "neskoab.EigentumVerteiler": "Eigentum/Verteiler (gemäss Amtliche Bewertung)",
  "neskoab.ErtragswertBGBB": "Ertragswert gemäss BGBB",
  "neskoab.GueltigAbSteuerjahr": "Gültig ab Steuerjahr",
  "neskoab.Mutationsdatum": "Mutationsdatum",
  "neskoab.Mutationsgrund": "Mutationsgrund",
  "neskoab.Nutzniesser": "Nutzniesser/in",
  "neskoab.Nutzniessung": "Nutzniessung",
  "neskoab.Objekte": "Objekte",
  "neskoab.SucheTitel": "Suche nach Spezialrecht der Amtliche Bewertung",
  "neskoab.Totalflaeche": "Totalfläche",
  "neskoab.nichtVerfuegbar": "Der Service von Nesko AB ist momentan nicht verfügbar!",
  "neskoabSearch.search.breadcrumb": "NESKOAB",
  "nichtBearbeitet": "Nicht bearbeitet",
  "nichtDefiniert": "Nicht definiert",
  "not.authorized": "Keine Berechtigung",
  "notAutorizedLoginRedirect": "Bitte loggen Sie sich erneut ein.",
  "notfount.title": "Kein Objekt gefunden.",
  "null": "null",
  "oereb.KeineInformationenVorhanden": "Keine Informationen vorhanden",
  "oereb.KeineOderNochKeineDatenVorhanden": "Keine oder noch keine Daten vorhanden",
  "oereb.auszugKompakt": "Auszug ÖREB-Kataster",
  "oereb.datenVonGrundstueck:": "Daten vom Stammgrundstück:",
  "oereb.nichtVerfuegbar": "Der Service des ÖREB-Katasters ist momentan nicht verfügbar!",
  "oereb.oerebsBetreffenGrundstueck": "Öffentlich-rechtliche Eigentumsbeschränkungen, welche das Grundstück betreffen",
  "oereb.oerebsBetreffenGrundstueckNicht": "Öffentlich-rechtliche Eigentumsbeschränkungen, welche das Grundstück nicht betreffen",
  "oereb.oerebsKeineDatenVorhanden": "Öffentlich-rechtliche Eigentumsbeschränkungen, zu denen noch keine Daten vorhanden sind",
  "ohneGrundbuchbezug": "Ohne Grundbuchbezug",
  "optimistic-lock.modal.back": "Nein, zurück",
  "optimistic-lock.modal.body": "Speichern ist nicht möglich, da die Daten in der Zwischenzeit verändert wurden. Daten neu laden?",
  "optimistic-lock.modal.continue": "Ja, neu laden",
  "optimistic-lock.modal.title": "Geänderte Daten",
  "person.SucheTitel": "Suche nach berechtigten Personen",
  "person.breadcrumbSuche": "Berechtigte Personen",
  "personDiffHint": "Grundbucheintragungen mit abweichenden Attributen zur Stammperson gefunden.",
  "persongb.addresssperre": "Bekanntgabe Adresse gesperrt",
  "persongb.auskunftssperre": "Auskunft zur Person gesperrt",
  "personstamm.GrundbuchBezug": "GB-Bezug",
  "personstamm.ListTitel": "Gefundene Stammpersonen",
  "personstamm.SucheTitel": "Suche nach Stammpersonen",
  "personstamm.ZPVNummer": "ZPV-Nummer",
  "personstamm.search.breadcrumb": "Stammpersonen",
  "personstamm.tab.ZPVSuche": "ZPV Suche",
  "projektiert": "projektiert",
  "publikation.ListTitel": "Gefundene Publikationen",
  "publikation.SucheTitel": "Suche nach Publikationen",
  "publikation.search.breadcrumb": "Publikationen",
  "publikation.suche": "Suche",
  "publikationAmtHeading": "Grundbuchgeschäft",
  "publikationDateHeading": "Publikationsdatum",
  "recht.search.breadcrumb": "Rechte",
  "rechte.SucheTitel": "Suche nach Rechten",
  "rechteId": "ID",
  "reset.check.modal.body": "Wollen Sie '{{entity}}' wirklich zurücksetzen?",
  "reset.check.modal.title": "Zurücksetzen",
  "rolle": "Rolle",
  "saveSuccessMessage": "Änderungen erfolgreich gespeichert.",
  "schnellsuche.help.attributes": "Die eingegebenen Suchkriterien werden gegen die folgenden Personenattribute geprüft (entsprechende Berechtigung vorausgesetzt):",
  "schnellsuche.help.city": "PLZ, Ort, Hausnummer und Firmensitz in Kombination mit weiteren Suchkriterien",
  "schnellsuche.help.exact": "Die Suchkriterien können durch \"\" weiter eingeschränkt werden. Die Felder in \"\" müssen exakt gefunden werden. Folgende Felder können so exakt durchsucht werden.",
  "schnellsuche.help.exact.addition": "Beispiel: Mira \"Muster\" \"Zürich\"",
  "schnellsuche.help.fuzzy": "Die Schnellsuche ignoriert Sonderzeichen und findet Namen bei leicht abweichender Schreibweise trotzdem. Gross- und Kleinschreibung wird ignoriert.",
  "schnellsuche.help.order": "Die Suchkriterien können in beliebiger Reihenfolge eingegeben werden.",
  "schnellsuche.help.suche": "Die Personensuche sucht nach rechtsgültigen und historisierten Einträgen.",
  "search.noResults": "Keine Treffer",
  "searchOhneProjektstatusZeitrahmenUndGrundstuecknummer": "Bei der Suche mit Projektstatus \"Alle\" muss zusätzlich nach dem Zeitrahmen oder der Grundstücknummer gesucht werden",
  "searchZeitrahmenOhneVonOderBis": "Bei der Suche mit einem Zeitrahmen müssen Von und Bis Datum angegeben werden",
  "searchZuVieleSuchkriterien": "Sie haben zu viele Suchkriterien eingegeben, bitte reduzieren Sie diese.",
  "searchZuWenigSuchkriterien": "Die Suchkriterien sind zu ungenau, bitte präzisieren Sie diese.",
  "searchbar.nichtRegistriert": "Um diese Funktion nutzen zu können, müssen Sie sich anmelden.",
  "searchbar.noResults": "Keine Grundstücke gefunden",
  "searchbar.placeholderText": "Suche nach Grundstücken",
  "searchbar.searchingText": "Bitte warten...",
  "searchperson.noResults": "Keine Personen gefunden",
  "searchperson.placeholderText": "Suche nach Person",
  "searchperson.searchingText": "Bitte Warten...",
  "security.actionUrl": "Aktion",
  "security.adminHint": "Wenden Sie sich bitte an Ihren Administrator.",
  "security.erweiterung": "Erweiterung",
  "security.kanton": "Kanton",
  "seit": "seit",
  "select.all": "Alle selektieren",
  "shared.breadcrumb.list": "Suchergebnis",
  "shared.logo.grundstueckInformationen": "Grundstückdaten-Informationssystem",
  "stammperson-adresssperre": "Bekanntgabe Adresse gesperrt.",
  "stammperson-adresssperre-mitBerechtigung": "Bekanntgabe Adresse gesperrt. Bitte keine Information weiter kommunizieren.",
  "stammperson-auskunftsperre": "Auskunft zur Person gesperrt.",
  "stammperson-auskunftsperre-mitBerechtigung": "Die Auskunft ist gesperrt. Bitte keine Information weiter kommunizieren.",
  "stapelverarbeitung.search.breadcrumb": "Stapelverarbeitung",
  "stichwortNichtVorhanden": "Die Stichwortsuche ergab kein Ergebnis.",
  "stime.amtlicheBewertung": "Amtliche Bewertung",
  "stime.chf": "CHF",
  "stime.description": "Beschreibung",
  "stime.flaeche": "Fläche (m²)",
  "stime.gebaeude": "Gebäude",
  "stime.gesamtflaeche": "Gesamtfläche m²",
  "stime.gesamtwert": "Gesamtwert geschätzt",
  "stime.land": "Land",
  "stime.schaetzung": "Schätzung (CHF)",
  "stime.validfrom": "Schätzung berechnet am",
  "successfullyLoggedOut": "Sie haben sich erfolgreich abgemeldet",
  "suche.status": "Status",
  "sucheNachGeometergeschäften": "Suche nach Geometergeschäften",
  "sucheNachGrundbuchgeschäften": "Suche nach Grundbuchgeschäften",
  "suchergebnis.EIGENTUEMER": "Eigentümerinnen und Eigentümer",
  "suchergebnis.GLAEUBIGER_SCHULDNER": "Gläubiger und Gläubigerinnen / Schuldner und Schuldnerinnen",
  "suchergebnis.UEBRIGE_BERECHTIGTE": "Übrige Berechtigte",
  "suchergebnis.gemeinden.PolitischeGemeinde": "Politische Gemeinde",
  "telefax": "Telefax",
  "telefonnummer1": "Telefonnummer 1",
  "titel.detail.geometergeschaeft": "Geometergeschäft",
  "titel.zentralePerson": "Zentrale Person",
  "title.AmtlicheBewertung": "Amtliche Bewertung",
  "title.AmtlicheVermessung": "Amtliche Vermessung",
  "title.Grundbuch": "Grundbuch",
  "tooltip.EIGENTUEMER": "Eigentumsverhältnisse zu {{person}}",
  "tooltip.GLAEUBIGER_SCHULDNER": "Gläubigerverhältnisse zu {{person}}",
  "tooltip.UEBRIGE_BERECHTIGTE": "Alle Berechtigungen von {{person}}",
  "tooltip.detailsAuftrag": "Details zu Auftrag anzeigen",
  "tooltip.detailsPersonGb": "Details zur Grundbuch-Person anzeigen.",
  "tooltip.detailsPersonStamm": "Details zur Stamm-Person {{person}} anzeigen.",
  "tooltip.detailsPersonZpv": "Details zur ZPV-Person {{person}} anzeigen.",
  "tooltip.meldungsempfaenger": "Details von Meldungsempfänger/in anzeigen",
  "tooltipHandelsangaben": "Handelsangaben anzeigen",
  "tooltipZusatzangaben": "Zusatzangaben anzeigen",
  "total": "Total",
  "true": "Ja",
  "uebersichtAmtlicheBewertungComponent": "Amtliche Bewertung",
  "uebersichtOerebPlaceHolderComponent": "ÖREB-Kataster",
  "uebrigeBerechtigungenImGrundbuch": "Übrige Berechtigungen im Grundbuch",
  "undefined": "unbekannt",
  "ungueltigeXmlDateiHochgeladen": "Die Hochgeladene XML Datei ist ungültig.",
  "unscharfeSuche": "unscharfe Suche",
  "unscharfeSucheTooltip": "Sonderzeichen/Diakritika werden unabhängig von dieser Suchoption in jedem Fall ignoriert",
  "unsupported.text": "Folgende Aktion wird nicht unterstützt, weil die benötigte Erweiterung nicht aktiv ist.",
  "unsupported.title": "Zugriff nicht unterstützt",
  "unterirdisch": "unterirdisch",
  "vergleichGbPersonZpvPerson": "Vergleich Grundbuchperson mit ZPV-Person",
  "version": "Version",
  "vertragsdaten.Eigentuemer": "Eigentümer/in",
  "vertragsdaten.RechtsgrundArt": "Rechtsgrundart",
  "vertragsdaten.RechtsgrundArt.ANDERE": "Andere",
  "vertragsdaten.RechtsgrundArt.GRENZAENDERUNG_SPEZIAL": "Grenzänderungen Spezialfälle",
  "vertragsdaten.RechtsgrundArt.HANDAENDERUNG_DRITTE": "Handänderung unter Dritten",
  "vertragsdaten.RechtsgrundArt.HANDAENDERUNG_EHEGATTEN": "Handänderung unter Ehegatten",
  "vertragsdaten.RechtsgrundArt.HANDAENDERUNG_ERBEN": "Handänderung an/unter Erben",
  "vertragsdaten.RechtsgrundArt.HANDAENDERUNG_GESELLSCHAFTEN": "Handänderung unter Gesellschaften",
  "vertragsdaten.RechtsgrundArt.HANDAENDERUNG_SPEZIAL": "Handänderung Spezialfälle",
  "vertragsdaten.RechtsgrundArt.SONSTIGE_SPEZIAL": "Sonstige Spezialfälle",
  "vertragsdatensatz": "Vertragsdatensatz",
  "vom": "vom",
  "von": "von",
  "wurdeErfolgreichGeloescht": "wurde erfolgreich gelöscht",
  "wurdeErfolgreichGespeichert": "wurde erfolgreich gespeichert",
  "zentraleNr": "Zentrale-Nr",
  "zpv.MaximalResultWarning": "Ergebnis unvollständig, da zu viele Einträge gefunden wurden. Bitte schränken Sie Ihre Suche ein.",
  "zpvService.nichtVerfuegbar": "Der ZPV Service ist momentan nicht verfügbar!",
  "zusatzangabenZuVeraeusserer": "Zusatzangaben zu Veräusserer",
  "zustaendigerNachfuehrungsgeometer": "Zuständiger Nachführungsgeometer",
  "zustaendigesGrundbuchamt": "Zuständiges Grundbuchamt",
  "{{label}} must be a valid date of the form 31.12.2018": "{{label}} muss ein korrektes Datum in der Form 31.12.2018 sein.",
  "{{label}} required": "{{label}} notwendig",
  "ÄnderungOhneGeschäft": "Änderung ohne Geschäft"
}